// de strings. Every key must exist in all four tables (npm run check:i18n).
export default {
  "nav.overview": "Übersicht",
  "nav.domains": "Domains",
  "nav.hosting": "Hosting",
  "nav.email": "E-Mail",
  "nav.backups": "Backups",
  "nav.billing": "Abrechnung",
  "nav.account": "Konto",
  "dash.subtitle": "Hier sehen Sie auf einen Blick, wie es um Ihre Dienste steht.",
  "status.allgood": "Alles läuft",
  "status.attention": "Aufmerksamkeit nötig",
  "qa.title": "Schnellaktionen",
  "qa.domain": "Domain hinzufügen",
  "qa.domain.d": "Registrieren oder umziehen",
  "qa.mailbox": "Postfach anlegen",
  "qa.mailbox.d": "Neue E-Mail-Adresse",
  "qa.dns": "DNS-Eintrag",
  "qa.dns.d": "Verweisen oder ändern",
  "qa.restore": "Backup wiederherstellen",
  "qa.restore.d": "Auf einen früheren Zeitpunkt",
  "svc.title": "Meine Websites",
  "svc.viewall": "Alle anzeigen",
  "svc.package": "Paket",
  "svc.mailboxes": "Postfächer",
  "svc.backup": "Letztes Backup",
  "svc.manage": "Verwalten",
  "svc.expires": "Nächste Rechnung",
  "use.title": "Nutzung",
  "use.disk": "Speicher",
  "use.traffic": "Datenverkehr",
  "use.mail": "Mail-Speicher",
  "use.of": "von",
  "act.title": "Letzte Aktivitäten",
  "act.viewall": "Alle anzeigen",
  "next.invoice.title": "Sie haben eine offene Rechnung",
  "next.invoices.title": "Sie haben offene Rechnungen",
  "next.invoice.body": "Offener Gesamtbetrag: {amount}.",
  "next.overdue.body": "Offener Gesamtbetrag: {amount}. Eine Rechnung ist überfällig.",
  "next.invoice.cta": "Rechnungen ansehen",
  "status.loading": "Status wird abgerufen…",
  "status.attention.n": "{n} Dienste brauchen Aufmerksamkeit",
  "status.attention.1": "1 Dienst braucht Aufmerksamkeit",
  "err.network": "Keine Verbindung zum Server. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
  "err.401": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "err.login.401": "E-Mail-Adresse oder Passwort ist falsch.",
  "err.login.mfa": "Ungültiger oder abgelaufener 2FA-Code.",
  "err.403": "Sie haben keinen Zugriff auf diesen Bereich.",
  "err.404": "Nicht gefunden. Möglicherweise wurde es gelöscht oder gehört nicht zu Ihrem Konto.",
  "err.409": "Dies existiert bereits oder steht im Konflikt mit einer bestehenden Einstellung.",
  "err.code.quota_exceeded": "Nicht genug Platz: {quota_mb} MB passen nicht, auf {domain} sind noch {left_mb} MB frei.",
  "err.422": "Nicht alle Felder sind korrekt ausgefüllt.",
  "err.429": "Zu viele Versuche. Warten Sie eine Minute und versuchen Sie es erneut.",
  "err.5xx": "Bei uns ist etwas schiefgelaufen. Bitte versuchen Sie es später erneut.",
  "err.generic": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  "common.everything_ok": "Alles läuft einwandfrei",
  "dom.title": "Domains",
  "dom.sub": "Verwalten Sie alle Ihre Domainnamen, DNS und Weiterleitungen an einem Ort.",
  "dom.add": "Domain hinzufügen",
  "dom.search": "Domain suchen…",
  "dom.filter.all": "Alle",
  "dom.filter.active": "Aktiv",
  "dom.filter.expiring": "Läuft bald ab",
  "dom.filter.transfer": "Im Umzug",
  "dom.col.domain": "Domain",
  "dom.col.linked": "Verknüpft mit",
  "dom.col.expires": "Läuft ab",
  "dom.col.autorenew": "Auto-Verlängerung",
  "dom.col.status": "Status",
  "dom.linked.hosting": "Hosting",
  "dom.linked.forward": "Weiterleitung",
  "dom.linked.parked": "Geparkt",
  "dom.status.active": "Aktiv",
  "dom.status.expiring": "Läuft in {n} Tagen ab",
  "dom.status.transfer": "Umzug",
  "dom.add.title": "Welche Domain möchten Sie?",
  "dom.add.placeholder": "z. B. meinefirma",
  "dom.add.btn": "Verfügbarkeit prüfen",
  "dom.add.transfer": "Bestehende Domain umziehen",
  "dd.back": "Alle Domains",
  "dd.tab.overview": "Übersicht",
  "dd.tab.dns": "DNS",
  "dd.tab.email": "Mail-Routing",
  "dd.tab.forward": "Weiterleitung",
  "dd.tab.settings": "Einstellungen",
  "dd.owner": "Inhaber",
  "dd.registered": "Registriert",
  "dd.expires": "Läuft ab am",
  "dd.renew": "Jetzt verlängern",
  "dd.autorenew": "Automatisch verlängern",
  "dd.autorenew.short": "Auto-Verlängerung",
  "common.yes": "Ja",
  "common.no": "Nein",
  "ar.off.title": "Automatische Verlängerung ausschalten?",
  "ar.off.body": "Möchten Sie diese Domain wirklich nicht verlängern? Die Domain wird dann gekündigt und ist nach dem Ablaufdatum nicht mehr erreichbar.",
  "ar.off.meta": "Läuft ab am",
  "ar.off.warning": "Nach dem Ablaufdatum kann die Domain von jemand anderem registriert werden.",
  "ar.off.cancel": "Abbrechen, weiter verlängern",
  "ar.off.confirm": "Ja, kündigen",
  "host.title": "Hosting",
  "host.sub": "Ihre Hosting-Pakete mit Spezifikationen und Verbrauch an einem Ort.",
  "host.new": "Neues Paket",
  "host.kpi.sites": "Aktive Websites",
  "host.kpi.storage": "Belegter Speicher",
  "host.kpi.traffic": "Datenverkehr diesen Monat",
  "host.banner.title": "PHP 8.3 ist für zwei Ihrer Websites bereit",
  "host.banner.body": "Wir haben das Upgrade bereits auf einer Staging-Kopie getestet. Sie können es mit einem Klick für einen ruhigen Zeitpunkt einplanen.",
  "host.banner.cta": "Upgrade planen",
  "host.pkg.title": "Pakete",
  "host.pkg.online": "Online",
  "host.spec.server": "Server",
  "host.spec.php": "PHP",
  "host.spec.ssl": "SSL",
  "host.spec.mailboxes": "Postfächer",
  "host.spec.lastbackup": "Letztes Backup",
  "host.usage.storage": "Speicher",
  "host.usage.traffic": "Datenverkehr",
  "host.usage.db": "Datenbank",
  "host.manage": "Verwalten",
  "host.upgrade": "Paket upgraden",
  "host.ssl.valid": "Gültig bis",
  "host.ssl.auto": "Erneuert sich automatisch",
  "host.tools.title": "Schnellwerkzeuge",
  "host.tools.files": "Dateiverwaltung",
  "host.tools.files.d": "Upload per FTP oder online",
  "host.tools.db": "Datenbank",
  "host.tools.db.d": "MySQL · phpMyAdmin",
  "host.tools.ssh": "SSH-Zugang",
  "host.tools.ssh.d": "Schlüssel verwalten",
  "host.tools.cron": "Cronjobs",
  "host.tools.cron.d": "Wiederkehrende Aufgaben planen",
  "host.server.title": "Server",
  "host.server.uptime": "Uptime 30 Tage",
  "host.server.location": "Eemshaven, NL",
  "host.summary.title": "Gesamtverbrauch",
  "host.summary.sub": "Über alle Pakete zusammen, diesen Monat.",
  "hd.back": "Alle Pakete",
  "hd.tab.overview": "Übersicht",
  "hd.tab.files": "Dateien",
  "hd.tab.db": "Datenbank",
  "hd.tab.ssh": "SSH",
  "hd.tab.cron": "Cronjobs",
  "hd.tab.settings": "Einstellungen",
  "hd.kpi.uptime": "Uptime 30 Tage",
  "hd.kpi.requests": "Anfragen heute",
  "hd.kpi.errors": "Fehler (24 h)",
  "hd.kpi.response": "Ø Antwortzeit",
  "hd.deploys": "Letzte Deployments",
  "hd.deploys.empty": "Noch keine Deployments.",
  "hd.access": "Zugangsdaten",
  "hd.access.ftp": "FTP / SFTP",
  "hd.access.ssh": "SSH",
  "hd.access.user": "Benutzer",
  "hd.access.host": "Host",
  "hd.access.port": "Port",
  "hd.access.path": "Webroot",
  "hd.files.upload": "Hochladen",
  "hd.files.new_folder": "Neuer Ordner",
  "hd.files.search": "Dateien durchsuchen…",
  "hd.files.col.name": "Name",
  "hd.files.col.size": "Größe",
  "hd.files.col.modified": "Geändert",
  "hd.db.create": "Neue Datenbank",
  "hd.db.open": "In phpMyAdmin öffnen",
  "hd.db.col.name": "Datenbank",
  "hd.db.col.size": "Größe",
  "hd.db.col.users": "Benutzer",
  "hd.db.col.engine": "Engine",
  "hd.ssh.cred": "Verbindungsdaten",
  "hd.ssh.keys": "Autorisierte Schlüssel",
  "hd.ssh.addkey": "Schlüssel hinzufügen",
  "hd.ssh.copy": "Befehl kopieren",
  "hd.ssh.key.added": "Hinzugefügt",
  "hd.cron.add": "Cronjob hinzufügen",
  "hd.cron.col.schedule": "Zeitplan",
  "hd.cron.col.cmd": "Befehl",
  "hd.cron.col.last": "Zuletzt ausgeführt",
  "hd.cron.col.status": "Status",
  "hd.set.php.title": "PHP-Version",
  "hd.set.php.sub": "Wählen Sie die PHP-Version für dieses Paket. Änderungen gelten sofort für die gesamte Website.",
  "hd.set.php.apply": "Version übernehmen",
  "hd.set.restart.title": "Paket neu starten",
  "hd.set.restart.sub": "Vorübergehend nicht erreichbar (~30 s). Nur verwenden, wenn die Website hängt.",
  "hd.set.restart.cta": "Jetzt neu starten",
  "hd.set.danger.title": "Paket kündigen",
  "hd.set.danger.sub": "Dieses Paket und alle Dateien löschen. Kann nicht rückgängig gemacht werden.",
  "hd.set.danger.cta": "Paket kündigen",
  "hp.new.title": "Neues Hosting-Paket",
  "hp.new.sub": "Wählen Sie ein Paket. Sie können später ohne Ausfallzeit upgraden.",
  "hp.new.month": "pro Monat",
  "hp.new.choose": "Dieses Paket wählen",
  "hp.new.popular": "Beliebt",
  "hp.new.feat.storage": "Speicher",
  "hp.new.feat.traffic": "Datenverkehr",
  "hp.new.feat.mail": "Postfächer",
  "hp.new.feat.db": "Datenbanken",
  "hp.new.feat.ssl": "SSL inklusive",
  "hp.new.feat.backup": "Tägliche Backups",
  "hp.new.feat.ssh": "SSH-Zugang",
  "hp.new.feat.staging": "Staging-Umgebung",
  "ht.scope": "Für",
  "ht.files.title": "Dateiverwaltung",
  "ht.files.sub": "Dateien für dieses Paket hochladen und verwalten.",
  "ht.db.title": "Datenbanken",
  "ht.db.sub": "MySQL-Datenbanken für dieses Paket.",
  "ht.ssh.title": "SSH-Zugang",
  "ht.ssh.sub": "Autorisierte Schlüssel und Verbindungseinstellungen verwalten.",
  "ht.cron.title": "Cronjobs",
  "ht.cron.sub": "Wiederkehrende Aufgaben planen, die auf dem Server laufen.",
  "act.download": "Herunterladen",
  "act.rename": "Umbenennen",
  "act.move": "Verschieben",
  "act.permissions": "Berechtigungen",
  "act.delete": "Löschen",
  "act.open": "In phpMyAdmin öffnen",
  "act.export": "Exportieren (SQL-Dump)",
  "act.import": "Dump importieren",
  "act.users": "Benutzer verwalten",
  "act.copy_pub": "Öffentlichen Schlüssel kopieren",
  "act.revoke": "Schlüssel widerrufen",
  "act.run_now": "Jetzt ausführen",
  "act.edit": "Bearbeiten",
  "act.view_logs": "Logs ansehen",
  "act.pause": "Pausieren",
  "act.resume": "Fortsetzen",
  "act.duplicate": "Duplizieren",
  "act.more": "Weitere Aktionen",
  "g.cancel": "Abbrechen",
  "g.save": "Speichern",
  "g.apply": "Übernehmen",
  "g.confirm": "Bestätigen",
  "mod.rename.title": "Umbenennen",
  "mod.rename.label": "Neuer Name",
  "mod.rename.save": "Umbenennen",
  "mod.move.title": "Verschieben",
  "mod.move.sub": "Wählen Sie den Zielordner. Dateien werden sofort verschoben.",
  "mod.move.current": "Aktueller Speicherort",
  "mod.move.target": "Zielordner",
  "mod.move.save": "Verschieben",
  "mod.perm.title": "Berechtigungen",
  "mod.perm.sub": "Legen Sie fest, wer was mit dieser Datei darf. Sofort aktiv.",
  "mod.perm.owner": "Eigentümer",
  "mod.perm.group": "Gruppe",
  "mod.perm.public": "Alle",
  "mod.perm.read": "Lesen",
  "mod.perm.write": "Schreiben",
  "mod.perm.exec": "Ausführen",
  "mod.perm.octal": "Oktalwert",
  "mod.delfile.title.file": "Datei löschen?",
  "mod.delfile.title.dir": "Ordner löschen?",
  "mod.delfile.body.file": "Diese Datei wird endgültig gelöscht. Dies kann nicht rückgängig gemacht werden.",
  "mod.delfile.body.dir": "Dieser Ordner und sein gesamter Inhalt werden endgültig gelöscht. Dies kann nicht rückgängig gemacht werden.",
  "mod.delfile.cta": "Ja, löschen",
  "mod.deldb.title": "Datenbank löschen?",
  "mod.deldb.body": "Alle Daten, Tabellen und Benutzer gehen verloren. Dies kann nicht rückgängig gemacht werden.",
  "mod.deldb.confirm": "Geben Sie zur Bestätigung den Namen der Datenbank ein",
  "mod.deldb.cta": "Datenbank löschen",
  "mod.exp.title": "Exportieren",
  "mod.exp.sub": "Erstellen Sie einen Dump, den Sie später importieren oder als Backup aufbewahren können.",
  "mod.exp.format": "Format",
  "mod.exp.compress": "Komprimieren (.gz)",
  "mod.exp.tables": "Tabellen",
  "mod.exp.tables.all": "Alle Tabellen",
  "mod.exp.tables.pick": "Tabellen auswählen",
  "mod.exp.structure": "Struktur",
  "mod.exp.data": "Daten",
  "mod.exp.start": "Export starten",
  "mod.imp.title": "Dump importieren",
  "mod.imp.sub": "Laden Sie eine .sql- oder .sql.gz-Datei hoch. Bestehende Tabellen werden überschrieben.",
  "mod.imp.drop": "Datei hierher ziehen oder zum Auswählen klicken",
  "mod.imp.replace": "Bestehende Tabellen überschreiben",
  "mod.imp.start": "Import starten",
  "mod.imp.warn": "Ein Import überschreibt Daten. Erstellen Sie vorher einen Export als Backup.",
  "mod.dbu.title": "Benutzer",
  "mod.dbu.sub": "Legen Sie fest, welche Benutzer Zugriff auf diese Datenbank haben.",
  "mod.dbu.add": "Benutzer hinzufügen",
  "mod.dbu.user": "Benutzer",
  "mod.dbu.host": "Host",
  "mod.dbu.priv": "Rechte",
  "mod.dbu.priv.ro": "Nur lesen",
  "mod.dbu.priv.rw": "Lesen & schreiben",
  "mod.dbu.priv.full": "Vollzugriff",
  "mod.dbu.new.user": "Benutzername",
  "mod.dbu.new.pwd": "Passwort",
  "mod.dbu.new.pwd.gen": "Generieren",
  "mod.dbu.remove": "Entfernen",
  "mod.revk.title": "Schlüssel widerrufen?",
  "mod.revk.body": "Nach dem Widerruf kann sich dieser Schlüssel nicht mehr am Server anmelden. Bestehende Verbindungen bleiben aktiv, bis sie geschlossen werden.",
  "mod.revk.cta": "Ja, widerrufen",
  "mod.cron.title.edit": "Cronjob bearbeiten",
  "mod.cron.title.new": "Neuer Cronjob",
  "mod.cron.preset": "Zeitplan",
  "mod.cron.preset.5min": "Alle 5 Minuten",
  "mod.cron.preset.hour": "Stündlich",
  "mod.cron.preset.day": "Jede Nacht 03:00",
  "mod.cron.preset.week": "Wöchentlich So 02:00",
  "mod.cron.preset.custom": "Eigener Zeitplan",
  "mod.cron.schedule": "Cron-Ausdruck",
  "mod.cron.cmd": "Befehl",
  "mod.cron.next": "Nächste Ausführung",
  "mod.clog.title": "Logs",
  "mod.clog.sub": "Letzte 30 Zeilen dieses Cronjobs.",
  "mod.cdel.title": "Cronjob löschen?",
  "mod.cdel.body": "Diese Aufgabe wird nach der Bestätigung nicht mehr ausgeführt. Dies kann nicht rückgängig gemacht werden.",
  "tst.download": "Download gestartet",
  "tst.copied": "In die Zwischenablage kopiert",
  "tst.renamed": "Umbenannt",
  "tst.moved": "Verschoben",
  "tst.perm_set": "Berechtigungen aktualisiert",
  "tst.deleted": "Gelöscht",
  "tst.exported": "Export eingeplant",
  "tst.imported": "Import gestartet",
  "tst.user_added": "Benutzer hinzugefügt",
  "tst.user_removed": "Benutzer entfernt",
  "tst.priv_changed": "Rechte geändert",
  "tst.key_revoked": "Schlüssel widerrufen",
  "tst.cron_run": "Cronjob gestartet",
  "tst.cron_duped": "Cronjob dupliziert",
  "tst.cron_paused": "Cronjob pausiert",
  "tst.cron_resumed": "Cronjob fortgesetzt",
  "tst.cron_saved": "Cronjob gespeichert",
  "tst.cron_deleted": "Cronjob gelöscht",
  "tst.phpmyadmin": "phpMyAdmin wird in einem neuen Tab geöffnet…",
  "mod.newdir.title": "Neuer Ordner",
  "mod.newdir.label": "Ordnername",
  "mod.newdir.cta": "Erstellen",
  "tst.created": "Erstellt",
  "mod.newdb.title": "Neue Datenbank",
  "mod.newdb.sub": "Geben Sie der Datenbank einen Namen. Verwenden Sie Unterstriche statt Leerzeichen.",
  "mod.newdb.label": "Name",
  "mod.newdb.cta": "Datenbank erstellen",
  "mod.upload.title": "Dateien hochladen",
  "mod.upload.sub": "Ziehen Sie Dateien hierher oder klicken Sie zur Auswahl.",
  "mod.upload.target": "Zielordner",
  "mod.upload.start": "Upload starten",
  "mod.upload.drop": "Dateien hierher ziehen oder zur Auswahl klicken",
  "tst.uploading": "Upload gestartet",
  "mod.addkey.title": "SSH-Schlüssel hinzufügen",
  "mod.addkey.sub": "Fügen Sie Ihren öffentlichen Schlüssel ein (beginnt mit ssh-rsa, ssh-ed25519, …).",
  "mod.addkey.label": "Name",
  "mod.addkey.label.placeholder": "z. B. Arbeitslaptop",
  "mod.addkey.key": "Öffentlicher Schlüssel",
  "mod.addkey.cta": "Schlüssel hinzufügen",
  "tst.key_added": "Schlüssel hinzugefügt",
  "mod.upgrade.title": "Paket upgraden",
  "mod.upgrade.sub": "Wählen Sie ein größeres Paket. Das Upgrade ist sofort aktiv, ohne Ausfallzeit.",
  "mod.upgrade.current": "Aktuelles Paket",
  "mod.upgrade.cta": "Jetzt upgraden",
  "tst.upgraded": "Paket aktualisiert",
  "mod.restart.body": "Die Website wird neu gestartet und ist etwa 30 Sekunden lang nicht erreichbar.",
  "mod.restart.cta": "Ja, neu starten",
  "tst.restarting": "Neustart gestartet…",
  "mod.canplan.body": "Das Paket sowie alle Dateien, Datenbanken und E-Mails werden gelöscht. Dies kann nicht rückgängig gemacht werden.",
  "mod.canplan.confirm": "Geben Sie zur Bestätigung die Domain ein",
  "tst.canceled": "Paket gekündigt",
  "mod.phpup.title": "PHP-8.3-Upgrade planen",
  "mod.phpup.sub": "Wählen Sie, wann wir das Upgrade durchführen. Währenddessen ist Ihre Website ca. 10 Sekunden nicht erreichbar.",
  "mod.phpup.when": "Wann",
  "mod.phpup.when.now": "Jetzt ausführen",
  "mod.phpup.when.tonight": "Heute Nacht 03:00",
  "mod.phpup.when.weekend": "Kommendes Wochenende",
  "mod.phpup.sites": "Websites, die aktualisiert werden",
  "mod.phpup.cta": "Upgrade planen",
  "tst.upgrade_scheduled": "Upgrade geplant",
  "tst.php_applied": "PHP-Version übernommen",
  "em.title": "E-Mail",
  "em.sub": "Verwalten Sie Postfächer, Aliasse, Weiterleitungen und Spamfilter.",
  "em.new": "Neue Adresse",
  "em.new.mailbox": "Postfach",
  "em.new.alias": "Alias",
  "em.new.forward": "Weiterleitung",
  "em.new.catchall": "Catch-all",
  "em.new.mailbox.d": "Eigenes Postfach mit IMAP/SMTP-Zugang.",
  "em.new.alias.d": "Zusätzliche Adresse, die in einem bestehenden Postfach ankommt.",
  "em.new.forward.d": "E-Mails an eine externe Adresse weiterleiten.",
  "em.new.catchall.d": "Alle E-Mails an diese Domain an einem Ort sammeln.",
  "em.new.helper": "Was möchten Sie erstellen?",
  "em.new.target": "Zustellen an",
  "em.new.forward_to": "Weiterleiten an",
  "em.search": "Postfach oder Alias suchen…",
  "em.filter.all": "Alle",
  "em.filter.mailbox": "Postfächer",
  "em.filter.alias": "Aliasse",
  "em.filter.forward": "Weiterleitungen",
  "em.kpi.mailboxes": "Aktive Postfächer",
  "em.kpi.storage": "Mail-Speicher",
  "em.kpi.spam": "Spam blockiert (24 h)",
  "em.kpi.delivered": "Heute zugestellt",
  "em.col.address": "Adresse",
  "em.col.type": "Typ",
  "em.col.usage": "Belegung",
  "em.col.last": "Letzte Anmeldung",
  "em.col.status": "Status",
  "em.type.mailbox": "Postfach",
  "em.type.alias": "Alias",
  "em.type.forward": "Weiterleitung",
  "em.type.catchall": "Catch-all",
  "em.status.active": "Aktiv",
  "em.status.full": "Fast voll",
  "em.status.vacation": "Abwesend",
  "em.status.paused": "Pausiert",
  "em.group.by_domain": "Nach Domain",
  "em.group.flat": "Einfache Liste",
  "em.banner.title": "Spamschutz ist aktiv",
  "em.banner.body": "Wir haben diese Woche 1.284 Nachrichten für Ihre Domains blockiert. Kein Handlungsbedarf.",
  "em.banner.cta": "Spam-Einstellungen",
  "ed.back": "Alle Postfächer",
  "ed.tab.overview": "Übersicht",
  "ed.tab.filters": "Filter",
  "ed.tab.forward": "Weiterleitung",
  "ed.tab.vacation": "Abwesenheit",
  "ed.tab.aliases": "Aliasse",
  "ed.tab.settings": "Einstellungen",
  "ed.kpi.in": "Heute eingegangen",
  "ed.kpi.out": "Heute gesendet",
  "ed.kpi.spam": "Spam",
  "ed.kpi.bounce": "Bounces",
  "ed.webmail": "Webmail öffnen",
  "ed.changepwd": "Passwort ändern",
  "ed.access.title": "Zugangsdaten",
  "ed.access.imap": "IMAP",
  "ed.access.smtp": "SMTP",
  "ed.access.host": "Host",
  "ed.access.port": "Port",
  "ed.access.user": "Benutzer",
  "ed.access.security": "Sicherheit",
  "ed.recent.title": "Letzte Aktivitäten",
  "ed.recent.empty": "Keine Aktivität in den letzten 7 Tagen.",
  "ed.devices.title": "Angemeldete Geräte",
  "ed.devices.logout": "Abmelden",
  "ef.title": "Filter",
  "ef.sub": "Nachrichten automatisch verschieben, markieren oder löschen.",
  "ef.add": "Filter hinzufügen",
  "ef.col.name": "Name",
  "ef.col.when": "Wenn",
  "ef.col.then": "Dann",
  "ef.empty.title": "Noch keine Filter",
  "ef.empty.sub": "Erstellen Sie Ihren ersten Filter, z. B.: alles von bookings@ in den Ordner Buchungen verschieben.",
  "ef.cond.from": "Absender enthält",
  "ef.cond.subject": "Betreff enthält",
  "ef.cond.to": "Empfänger enthält",
  "ef.cond.body": "Nachricht enthält",
  "ef.act.folder": "In Ordner verschieben",
  "ef.act.label": "Label hinzufügen",
  "ef.act.flag": "Als wichtig markieren",
  "ef.act.delete": "Sofort löschen",
  "ef.act.forward": "Weiterleiten an",
  "evf.title": "Weiterleitung",
  "evf.sub": "Eingehende E-Mails automatisch an eine andere Adresse weiterleiten.",
  "evf.on": "Weiterleitung an",
  "evf.to": "An",
  "evf.keep": "Kopie in diesem Postfach behalten",
  "evf.add_to": "Adresse hinzufügen",
  "evf.empty": "Fügen Sie mindestens eine Adresse für die Weiterleitung hinzu.",
  "ev.title": "Abwesenheitsnotiz",
  "ev.sub": "Automatisch antworten, wenn Sie nicht erreichbar sind.",
  "ev.on": "Abwesenheitsnotiz an",
  "ev.from": "Von",
  "ev.until": "Bis",
  "ev.subject": "Betreff",
  "ev.message": "Nachricht",
  "ev.once": "Einmal pro Absender",
  "ea.title": "Aliasse",
  "ea.sub": "Zusätzliche Adressen, die in diesem Postfach ankommen.",
  "ea.add": "Alias hinzufügen",
  "ea.col.alias": "Alias",
  "ea.col.target": "Kommt an in",
  "ea.empty.title": "Keine Aliasse",
  "ea.empty.sub": "Legen Sie zum Beispiel info@ oder contact@ als Alias für dieses Postfach an.",
  "es.title": "Einstellungen",
  "es.quota.title": "Speicherlimit",
  "es.quota.sub": "Maximale Größe dieses Postfachs.",
  "es.spam.title": "Spamfilter",
  "es.spam.sub": "Legen Sie fest, wie streng wir Spam filtern.",
  "es.spam.strict": "Streng",
  "es.spam.balanced": "Ausgewogen",
  "es.spam.lenient": "Locker",
  "es.smtp.title": "Externes SMTP erlauben",
  "es.smtp.sub": "Von externen Geräten über dieses Postfach senden.",
  "es.danger.title": "Postfach löschen",
  "es.danger.sub": "Dieses Postfach und alle Nachrichten löschen. Kann nicht rückgängig gemacht werden.",
  "es.danger.cta": "Postfach löschen",
  "mod.nm.title": "Neues Postfach",
  "mod.nm.sub": "Legen Sie ein Postfach für eine Ihrer Domains an.",
  "mod.nm.local": "Adresse",
  "mod.nm.domain": "Domain",
  "mod.nm.pwd": "Passwort",
  "mod.nm.pwd.gen": "Generieren",
  "mod.nm.quota": "Speicherlimit",
  "mod.nm.cta": "Postfach anlegen",
  "mod.pwd.title": "Passwort ändern",
  "mod.pwd.sub": "Das neue Passwort gilt sofort. Angemeldete Programme müssen sich erneut anmelden.",
  "mod.pwd.new": "Neues Passwort",
  "mod.pwd.confirm": "Passwort bestätigen",
  "mod.pwd.show": "Anzeigen",
  "mod.pwd.hide": "Verbergen",
  "mod.pwd.cta": "Passwort speichern",
  "mod.pwd.mismatch": "Die Passwörter stimmen nicht überein.",
  "mod.pwd.weak": "Das Passwort ist zu schwach. Verwenden Sie mindestens 10 Zeichen.",
  "mod.alias.title": "Alias hinzufügen",
  "mod.alias.sub": "Legen Sie eine neue Adresse an, die in diesem Postfach ankommt.",
  "mod.alias.local": "Alias",
  "mod.alias.domain": "Domain",
  "mod.alias.cta": "Alias anlegen",
  "mod.efilter.title.edit": "Filter bearbeiten",
  "mod.efilter.title.new": "Neuer Filter",
  "mod.efilter.name": "Name",
  "mod.efilter.if": "Wenn",
  "mod.efilter.value": "Wert",
  "mod.efilter.then": "Dann",
  "mod.efilter.cta": "Filter speichern",
  "mod.delmb.title": "Postfach löschen?",
  "mod.delmb.body": "Alle Nachrichten gehen verloren. Dies kann nicht rückgängig gemacht werden.",
  "mod.delmb.confirm": "Geben Sie zur Bestätigung die Adresse ein",
  "mod.delmb.cta": "Postfach löschen",
  "eact.webmail": "Webmail öffnen",
  "eact.pwd": "Passwort ändern",
  "eact.forward": "Weiterleitung einrichten",
  "eact.vacation": "Abwesenheitsnotiz einschalten",
  "eact.alias": "Alias hinzufügen",
  "eact.pause": "Postfach pausieren",
  "eact.resume": "Postfach fortsetzen",
  "eact.delete": "Löschen",
  "tst.mb_created": "Postfach angelegt",
  "tst.mb_deleted": "Postfach gelöscht",
  "tst.pwd_changed": "Passwort geändert",
  "tst.alias_added": "Alias hinzugefügt",
  "tst.alias_removed": "Alias entfernt",
  "tst.filter_saved": "Filter gespeichert",
  "tst.filter_deleted": "Filter gelöscht",
  "tst.vacation_on": "Abwesenheitsnotiz eingeschaltet",
  "tst.vacation_off": "Abwesenheitsnotiz ausgeschaltet",
  "tst.forward_on": "Weiterleitung aktiviert",
  "tst.forward_off": "Weiterleitung deaktiviert",
  "tst.mb_paused": "Postfach pausiert",
  "tst.mb_resumed": "Postfach fortgesetzt",
  "tst.webmail": "Webmail wird in einem neuen Tab geöffnet…",
  "mod.edit_alias.title.alias": "Alias bearbeiten",
  "mod.edit_alias.title.forward": "Weiterleitung bearbeiten",
  "mod.edit_alias.title.catchall": "Catch-all bearbeiten",
  "mod.edit_alias.from": "Adresse",
  "mod.edit_alias.to": "Kommt an in",
  "mod.edit_alias.to.external": "Weiterleiten an",
  "tst.edited": "Aktualisiert",
  "spam.title": "Spam-Einstellungen",
  "spam.sub": "Wie streng sollen wir Spam für alle Ihre Domains filtern?",
  "spam.level": "Filterstufe",
  "spam.lvl.strict": "Streng",
  "spam.lvl.strict.d": "Alles auch nur leicht Verdächtige wird blockiert. Gelegentlich Fehlalarme.",
  "spam.lvl.balanced": "Ausgewogen",
  "spam.lvl.balanced.d": "Unsere Empfehlung. Spam in den Spam-Ordner, Zweifelsfälle mit Label zustellen.",
  "spam.lvl.lenient": "Locker",
  "spam.lvl.lenient.d": "Nur eindeutigen Spam blockieren. Mehr im Posteingang, auch Spam.",
  "spam.greylist": "Greylisting",
  "spam.greylist.d": "Unbekannte Absender einmal abweisen. Wirksam gegen Bots; die Zustellung verzögert sich etwas.",
  "spam.blocklist": "Sperrliste",
  "spam.blocklist.add": "Adresse oder Domain hinzufügen",
  "spam.allowlist": "Zulassen",
  "spam.allowlist.add": "Adresse oder Domain hinzufügen",
  "spam.scope": "Gilt für",
  "spam.scope.all": "Alle Domains",
  "spam.scope.pick": "Pro Domain",
  "tst.spam_saved": "Spam-Einstellungen gespeichert",
  "mod.devlogout.title": "Gerät abmelden?",
  "mod.devlogout.body": "Das Gerät muss sich erneut anmelden, um wieder auf dieses Postfach zuzugreifen.",
  "mod.devlogout.cta": "Ja, abmelden",
  "tst.dev_logged_out": "Gerät abgemeldet",
  "bk.title": "Backups",
  "bk.sub": "Automatische tägliche Backups für alle Ihre Websites und Postfächer. Schnell zurück zu jedem früheren Zeitpunkt.",
  "bk.new": "Jetzt Backup erstellen",
  "bk.schedule": "Zeitplan bearbeiten",
  "bk.kpi.last": "Letztes Backup",
  "bk.kpi.success": "Erfolgreich (30 T.)",
  "bk.kpi.storage": "Backup-Speicher",
  "bk.kpi.retention": "Aufbewahrung",
  "bk.banner.title": "Alles läuft. Backups gestern um 04:12 abgeschlossen.",
  "bk.banner.body": "3 Websites und 9 Postfächer erfolgreich gesichert. Kein Handlungsbedarf.",
  "bk.banner.cta": "Aktivitätsprotokoll",
  "bk.list.title": "Pro Website",
  "bk.col.site": "Website",
  "bk.col.last": "Letztes Backup",
  "bk.col.snapshots": "Snapshots",
  "bk.col.size": "Größe",
  "bk.col.next": "Nächstes Backup",
  "bk.col.status": "Status",
  "bk.status.healthy": "In Ordnung",
  "bk.status.warn": "Aufmerksamkeit nötig",
  "bk.status.running": "Läuft",
  "bk.snapshots.title": "Snapshots",
  "bk.snapshots.sub": "Jeder Snapshot enthält Dateien, Datenbanken und Postfächer zu diesem Zeitpunkt.",
  "bk.snap.col.when": "Wann",
  "bk.snap.col.kind": "Typ",
  "bk.snap.col.size": "Größe",
  "bk.snap.col.includes": "Inhalt",
  "bk.snap.col.retention": "Aufbewahrt bis",
  "bk.snap.kind.daily": "Täglich",
  "bk.snap.kind.weekly": "Wöchentlich",
  "bk.snap.kind.monthly": "Monatlich",
  "bk.snap.kind.manual": "Manuell",
  "bk.snap.kind.predeploy": "Vor Deployment",
  "bk.tab.snapshots": "Snapshots",
  "bk.tab.settings": "Einstellungen",
  "bk.tab.activity": "Aktivität",
  "bk.act.restore": "Wiederherstellen",
  "bk.act.download": "Herunterladen (.zip)",
  "bk.act.contents": "Inhalt anzeigen",
  "bk.act.lock": "Länger aufbewahren",
  "bk.act.unlock": "Nicht länger aufbewahren",
  "bk.act.delete": "Snapshot löschen",
  "bk.set.freq.title": "Häufigkeit",
  "bk.set.freq.sub": "Wie oft wir automatisch ein Backup erstellen.",
  "bk.set.freq.hourly": "Stündlich",
  "bk.set.freq.daily": "Täglich",
  "bk.set.freq.twice": "2× täglich",
  "bk.set.ret.title": "Aufbewahrung",
  "bk.set.ret.sub": "Wie lange wir jede Art von Snapshot aufbewahren.",
  "bk.set.ret.daily": "Tägliche",
  "bk.set.ret.weekly": "Wöchentliche",
  "bk.set.ret.monthly": "Monatliche",
  "bk.set.scope.title": "Was ein Backup enthält",
  "bk.set.scope.sub": "Deaktivieren Sie Bestandteile, die Sie nicht sichern möchten.",
  "bk.set.scope.files": "Dateien",
  "bk.set.scope.db": "Datenbanken",
  "bk.set.scope.mail": "Postfächer",
  "bk.set.offsite.title": "Off-site-Replikation",
  "bk.set.offsite.sub": "Zweite Kopie in einem anderen Rechenzentrum (Eemshaven → Groningen).",
  "bk.includes.files": "Dateien",
  "bk.includes.db": "Datenbanken",
  "bk.includes.mail": "Postfächer",
  "bk.activity.title": "Aktivität",
  "bk.activity.empty": "Diese Woche noch keine Aktivität.",
  "mod.restore.title": "Snapshot wiederherstellen",
  "mod.restore.sub": "Wählen Sie, was wiederhergestellt werden soll und wohin. Wir erstellen vorher noch einen Sicherheits-Snapshot.",
  "mod.restore.what": "Was wiederherstellen",
  "mod.restore.what.all": "Alles",
  "mod.restore.what.files": "Nur Dateien",
  "mod.restore.what.db": "Nur Datenbanken",
  "mod.restore.what.mail": "Nur Postfächer",
  "mod.restore.where": "Wohin",
  "mod.restore.where.live": "In die Live-Website",
  "mod.restore.where.staging": "In die Staging-Umgebung",
  "mod.restore.dry": "Testlauf: Änderungen anzeigen, nichts ausführen",
  "mod.restore.cta": "Wiederherstellung starten",
  "mod.restore.warn": "Die Wiederherstellung überschreibt die aktuellen Dateien und Datenbanken. Erstellen Sie vorher ein manuelles Backup, wenn Sie auf Nummer sicher gehen möchten.",
  "mod.restore.files.title": "Dateien",
  "mod.restore.files.all": "Alle Dateien",
  "mod.restore.files.pick": "Ordner auswählen",
  "mod.restore.files.hint": "Markieren Sie Ordner/Dateien, um nur diese wiederherzustellen.",
  "mod.restore.db.title": "Datenbanken",
  "mod.restore.db.all": "Alle Datenbanken",
  "mod.restore.db.pick": "Datenbanken auswählen",
  "mod.restore.mail.title": "Postfächer",
  "mod.restore.mail.all": "Alle Postfächer",
  "mod.restore.mail.pick": "Postfächer auswählen",
  "mod.restore.where.sub": "In eine Subdomain",
  "mod.restore.sub.label": "Subdomain",
  "mod.restore.sub.help": "Wir stellen den Snapshot in einer temporären Kopie wieder her. Ihre Live-Website bleibt unverändert.",
  "mod.restore.sub.preview": "Erreichbar unter",
  "mod.restore.summary": "Wird wiederhergestellt",
  "mod.restore.summary.empty": "Wählen Sie oben mindestens einen Bereich aus.",
  "mod.bnow.title": "Jetzt ein Backup erstellen",
  "mod.bnow.sub": "Erstellen Sie manuell einen Snapshot. Praktisch vor einem größeren Update.",
  "mod.bnow.scope": "Was einschließen",
  "mod.bnow.label": "Bezeichnung (optional)",
  "mod.bnow.label.ph": "z. B. Vor dem Upgrade auf PHP 8.3",
  "mod.bnow.lock": "Nicht automatisch aufräumen",
  "mod.bnow.cta": "Backup starten",
  "mod.snap.title": "Inhalt des Snapshots",
  "mod.snap.files": "Dateien",
  "mod.snap.db": "Datenbanken",
  "mod.snap.mail": "Postfächer",
  "mod.snap.size": "Größe",
  "mod.snap.count": "Anzahl",
  "mod.snap.kind": "Typ",
  "mod.snap.created": "Erstellt",
  "mod.delsnap.title": "Snapshot löschen?",
  "mod.delsnap.body": "Der Snapshot wird sofort gelöscht. Andere Snapshots bleiben verfügbar.",
  "tst.backup_started": "Backup gestartet",
  "tst.backup_done": "Backup abgeschlossen",
  "tst.restore_started": "Wiederherstellung gestartet",
  "tst.snapshot_locked": "Snapshot angeheftet",
  "tst.snapshot_unlocked": "Snapshot freigegeben",
  "tst.snapshot_deleted": "Snapshot gelöscht",
  "tst.schedule_saved": "Zeitplan gespeichert",
  "bl.title": "Abrechnung",
  "bl.sub": "Rechnungen, Zahlungsmethoden und Abonnements an einem Ort.",
  "bl.pay": "Offene Beträge bezahlen",
  "bl.pay_method": "Zahlungsmethode ändern",
  "bl.address": "Rechnungsadresse",
  "bl.kpi.open": "Offen",
  "bl.kpi.this_month": "Dieser Monat",
  "bl.kpi.next": "Nächste Rechnung",
  "bl.kpi.method": "Zahlungsmethode",
  "bl.banner.title": "5 % sparen mit SEPA-Lastschrift",
  "bl.banner.body": "Wir buchen automatisch am Fälligkeitsdatum ab. Mit einem Klick umstellen.",
  "bl.banner.cta": "Lastschrift aktivieren",
  "bl.invoices.title": "Aktuelle Rechnungen",
  "bl.invoices.viewall": "Alle anzeigen",
  "bl.col.number": "Rechnungsnummer",
  "bl.col.date": "Datum",
  "bl.col.amount": "Betrag",
  "bl.col.due": "Fälligkeitsdatum",
  "bl.col.status": "Status",
  "bl.status.paid": "Bezahlt",
  "bl.status.open": "Offen",
  "bl.status.overdue": "Überfällig",
  "bl.status.draft": "Entwurf",
  "bl.subs.title": "Abonnements",
  "bl.subs.cancel": "Kündigen",
  "bl.subs.viewall": "Abonnements verwalten",
  "bl.methods.title": "Zahlungsmethoden",
  "bl.methods.add": "Methode hinzufügen",
  "bl.methods.primary": "Standard",
  "bl.methods.set_primary": "Als Standard festlegen",
  "bl.methods.remove": "Entfernen",
  "bl.address.title": "Rechnungsadresse",
  "bl.address.edit": "Bearbeiten",
  "bd.back": "Alle Rechnungen",
  "bd.invoice": "Rechnung",
  "bd.items.title": "Positionen",
  "bd.items.col.desc": "Beschreibung",
  "bd.items.col.period": "Zeitraum",
  "bd.items.col.qty": "Menge",
  "bd.items.col.price": "Einzelpreis",
  "bd.items.col.amount": "Betrag",
  "bd.items.subtotal": "Zwischensumme",
  "bd.items.vat": "MwSt. (21 %)",
  "bd.items.total": "Gesamt",
  "bd.actions.download": "PDF herunterladen",
  "bd.actions.send": "Kopie senden",
  "bd.actions.print": "Drucken",
  "bd.actions.pay": "Jetzt bezahlen",
  "bd.history.title": "Verlauf",
  "bd.notes.title": "Notizen",
  "bd.notes.empty": "Keine Notizen zu dieser Rechnung.",
  "mod.pay.title": "Rechnung bezahlen",
  "mod.pay.sub": "Wählen Sie eine Zahlungsmethode. Der Betrag wird sofort verrechnet.",
  "mod.pay.amount": "Betrag",
  "mod.pay.method": "Methode",
  "mod.pay.cta": "Jetzt bezahlen",
  "mod.pm.title": "Zahlungsmethode hinzufügen",
  "mod.pm.sub": "Wählen Sie eine Zahlungsmethode. Wir speichern sie sicher für wiederkehrende Zahlungen.",
  "mod.pm.kind": "Typ",
  "mod.pm.kind.ideal": "iDEAL",
  "mod.pm.kind.card": "Kreditkarte",
  "mod.pm.kind.sepa": "SEPA-Lastschrift",
  "mod.pm.bank": "Bank",
  "mod.pm.iban": "IBAN",
  "mod.pm.holder": "Kontoinhaber",
  "mod.pm.card.num": "Kartennummer",
  "mod.pm.card.exp": "Gültig bis",
  "mod.pm.card.cvc": "CVC",
  "mod.pm.cta": "Methode hinzufügen",
  "mod.pm.set_primary": "Als Standardmethode festlegen",
  "mod.addr.title": "Rechnungsadresse bearbeiten",
  "mod.addr.company": "Firma",
  "mod.addr.attn": "z. Hd.",
  "mod.addr.street": "Straße",
  "mod.addr.zip": "PLZ",
  "mod.addr.city": "Ort",
  "mod.addr.country": "Land",
  "mod.addr.vat": "USt-IdNr.",
  "mod.addr.email": "E-Mail für Rechnungen",
  "mod.addr.cta": "Speichern",
  "mod.canceluse.title": "Abonnement kündigen?",
  "mod.canceluse.body": "Das Abonnement läuft bis zum Ende des aktuellen Zeitraums weiter. Danach wird das Paket deaktiviert.",
  "mod.canceluse.cta": "Ja, kündigen",
  "tst.invoice_paid": "Rechnung bezahlt",
  "tst.payment_started": "Zahlung gestartet",
  "tst.method_added": "Methode hinzugefügt",
  "tst.method_removed": "Methode entfernt",
  "tst.method_primary": "Standardmethode festgelegt",
  "tst.address_saved": "Adresse gespeichert",
  "tst.subscription_canceled": "Abonnement gekündigt",
  "tst.invoice_sent": "Rechnung gesendet",
  "tst.print": "Druckdialog wird geöffnet…",
  "dd.nameservers": "Nameserver",
  "dd.lock": "Transfersperre",
  "dd.linked.title": "Verknüpfte Dienste",
  "dns.simple": "Einfacher Modus",
  "dns.advanced": "Erweitert",
  "dns.tasks.title": "Was möchten Sie tun?",
  "dns.tasks.sub": "Wählen Sie eine häufige Aufgabe – wir richten die DNS-Einträge für Sie ein.",
  "dns.task.website": "Auf meine Website verweisen",
  "dns.task.website.d": "A- und CNAME-Einträge setzen, damit Besucher Ihre Website erreichen.",
  "dns.task.mail": "Meine E-Mail läuft über…",
  "dns.task.mail.d": "MX-Einträge für Google Workspace, Microsoft 365 oder DMRS Mail konfigurieren.",
  "dns.task.verify": "Einen Dienst verifizieren",
  "dns.task.verify.d": "Einen TXT-Eintrag hinzufügen, um den Besitz nachzuweisen (Google, Meta, …).",
  "dns.task.forward": "Auf eine andere URL weiterleiten",
  "dns.task.forward.d": "Besucher dieser Domain z. B. auf example.com weiterleiten.",
  "dns.records.title": "Alle DNS-Einträge",
  "dns.records.add": "Eintrag hinzufügen",
  "dns.records.help": "Unsicher? Nutzen Sie oben den einfachen Modus.",
  "dns.col.type": "Typ",
  "dns.col.name": "Name",
  "dns.col.value": "Wert",
  "dns.col.ttl": "TTL",
  "tw.title": "{domain} auf Ihre Website verweisen",
  "tw.sub": "Wählen Sie, wo Ihre Website läuft. Wir setzen die passenden DNS-Einträge.",
  "tw.opt.dmrs": "DMRS Hosting (dieser Kunde)",
  "tw.opt.ip": "Eine andere IP-Adresse",
  "tw.opt.host": "Ein anderer Hostname (z. B. meineseite.netlify.app)",
  "tw.cancel": "Abbrechen",
  "tw.apply": "Übernehmen",
  "tw.preview": "Wir legen diese Einträge an:",
  "mr.title": "E-Mail-Routing",
  "mr.sub": "Legen Sie fest, welcher Server die E-Mails für diese Domain empfängt.",
  "mr.current": "Aktuelle Einstellung",
  "mr.change": "Anbieter wechseln",
  "mr.preset.dmrs": "DMRS Mail",
  "mr.preset.dmrs.d": "In Ihrem Hosting-Paket enthalten. 6 Postfächer aktiv.",
  "mr.preset.google": "Google Workspace",
  "mr.preset.google.d": "Gmail für Ihre Domain. Erfordert ein Workspace-Konto.",
  "mr.preset.ms": "Microsoft 365",
  "mr.preset.ms.d": "Outlook für Ihre Domain. Erfordert ein M365-Konto.",
  "mr.preset.none": "Keine E-Mail",
  "mr.preset.none.d": "Keine E-Mails für diese Domain empfangen. Entfernt die MX-Einträge.",
  "mr.preset.custom": "Anderer Anbieter",
  "mr.preset.custom.d": "Eigene MX-Einträge eingeben (z. B. Fastmail, ProtonMail).",
  "mr.deliverability": "Zustellbarkeit",
  "mr.spf": "SPF",
  "mr.dkim": "DKIM",
  "mr.dmarc": "DMARC",
  "mr.healthy": "Korrekt eingerichtet",
  "fw.title": "Weiterleitung",
  "fw.sub": "Besucher automatisch auf eine andere URL weiterleiten.",
  "fw.add": "Weiterleitung hinzufügen",
  "fw.col.from": "Von",
  "fw.col.to": "Nach",
  "fw.col.type": "Typ",
  "fw.col.code": "Statuscode",
  "fw.type.permanent": "Dauerhaft",
  "fw.type.temporary": "Vorübergehend",
  "fw.empty.title": "Noch keine Weiterleitungen",
  "fw.empty.sub": "Leiten Sie zum Beispiel die ganze Domain auf eine andere Adresse weiter oder /blog auf Ihr Medium.",
  "ds.title": "Einstellungen",
  "ds.sub": "Kontaktdaten, Nameserver und Domaintransfer.",
  "ds.contact.title": "Kontaktdaten",
  "ds.contact.sub": "Werden für WHOIS und offizielle Mitteilungen der Registry verwendet.",
  "ds.contact.edit": "Kontakte bearbeiten",
  "ds.ns.title": "Nameserver",
  "ds.ns.sub": "Standardmäßig zeigen sie auf die DMRS-Nameserver. Ändern Sie dies nur, wenn Sie wissen, was Sie tun.",
  "ds.ns.use_dmrs": "DMRS-Nameserver verwenden",
  "ds.ns.custom": "Eigene Nameserver",
  "ds.danger.title": "Domain umziehen",
  "ds.danger.sub": "Fordern Sie einen Transfercode an, um diese Domain zu einem anderen Registrar umzuziehen.",
  "ds.danger.get": "Transfercode anfordern",
  "ds.dnssec.title": "DNSSEC",
  "ds.dnssec.sub": "Schützt DNS-Antworten vor Fälschung. Empfohlen.",
  "ds.dnssec.active": "DNSSEC aktiv",
  "ds.dnssec.algo": "Algorithmus",
  "ds.dnssec.keytag": "Key-Tag",
  "ds.dnssec.ds": "DS-Eintrag",
  "ds.dnssec.keys.title": "Eigene DS-Einträge",
  "ds.dnssec.keys.sub": "Fügen Sie die DS-Einträge Ihres externen DNS-Anbieters hinzu.",
  "ds.dnssec.keys.add": "DS-Eintrag hinzufügen",
  "ds.dnssec.keys.empty": "Noch keine eigenen DS-Einträge. DMRS verwaltet die Schlüssel.",
  "mod.dnssec.title": "DS-Eintrag hinzufügen",
  "mod.dnssec.keytag": "Key-Tag",
  "mod.dnssec.algo": "Algorithmus",
  "mod.dnssec.digestType": "Digest-Typ",
  "mod.dnssec.digest": "Digest",
  "mod.dnssec.cta": "DS-Eintrag hinzufügen",
  "tst.ds_added": "DS-Eintrag hinzugefügt",
  "tst.ds_removed": "DS-Eintrag entfernt",
  "mod.contacts.title": "Kontakte bearbeiten",
  "mod.contacts.sub": "Inhaber und technischer Kontakt werden für WHOIS und offizielle Mitteilungen der Registry verwendet.",
  "mod.contacts.role.holder": "Inhaber",
  "mod.contacts.role.tech": "Technischer Kontakt",
  "mod.contacts.role.admin": "Administrativer Kontakt",
  "mod.contacts.role.billing": "Rechnungskontakt",
  "mod.contacts.name": "Name",
  "mod.contacts.email": "E-Mail",
  "mod.contacts.phone": "Telefon",
  "mod.contacts.handle": "Handle",
  "mod.contacts.handle.ph": "z. B. JANS001",
  "mod.contacts.handle.search": "Handle suchen",
  "mod.contacts.handle.searching": "Wird gesucht…",
  "mod.contacts.handle.notfound": "Kein Handle gefunden – bitte manuell eingeben.",
  "mod.contacts.handle.help": "Registry-Handle dieses Kontakts. Wird später automatisch abgerufen.",
  "tst.contacts_saved": "Kontakte gespeichert",
  "mod.transfer.method": "Code erhalten per",
  "mod.transfer.method.email": "Sichere E-Mail",
  "mod.transfer.method.sms": "SMS an die registrierte Nummer",
  "mod.transfer.method.email.d": "Wir senden den Code an die Adresse des Inhabers. Sicherer: nicht im Panel sichtbar.",
  "mod.transfer.dnssec.title": "Schalten Sie zuerst DNSSEC aus",
  "mod.transfer.dnssec.body": "Viele Transfers scheitern, weil DNSSEC beim alten Registrar noch aktiv ist. Schalten Sie es hier aus, damit der neue Registrar es neu einrichten kann.",
  "mod.transfer.dnssec.cta": "DNSSEC ausschalten",
  "mod.transfer.dnssec.skip": "DNSSEC eingeschaltet lassen",
  "mod.transfer.send": "Transfercode senden",
  "tst.transfer_sent": "Transfercode an Ihre E-Mail-Adresse gesendet",
  "ds.ns.save": "Nameserver speichern",
  "ds.ns.invalid": "Geben Sie mindestens 2 gültige Nameserver ein.",
  "mod.ns.title": "Nameserver ändern?",
  "mod.ns.body": "Eine Änderung kann bis zu 24 Std. dauern, bis sie weltweit wirksam ist. In dieser Zeit sind Ihre Website oder E-Mail möglicherweise kurz nicht erreichbar.",
  "mod.ns.cta": "Ja, Nameserver ändern",
  "tst.ns_saved": "Nameserver gespeichert",
  "tst.dnssec_on": "DNSSEC eingeschaltet",
  "tst.dnssec_off": "DNSSEC ausgeschaltet",
  "mod.transfer.title": "Transfercode anfordern",
  "mod.transfer.sub": "Geben Sie diesen Code Ihrem neuen Registrar, um die Domain dorthin umzuziehen.",
  "mod.transfer.code": "Transfercode",
  "mod.transfer.warn": "Sobald der Transfer gestartet ist, können Sie hier keine Änderungen mehr vornehmen. Brechen Sie laufende Änderungen vorher ab.",
  "mod.transfer.copy": "Code kopieren",
  "mod.transfer.email": "An meine E-Mail senden",
  "tst.transfer_code": "Transfercode neu erstellt",
  "mm.title": "Meine E-Mail läuft über…",
  "mm.sub": "Wählen Sie Ihren E-Mail-Anbieter. Wir richten die passenden MX-Einträge für Sie ein.",
  "mm.confirm": "MX-Einträge jetzt ersetzen",
  "vm.title": "Einen Dienst verifizieren",
  "vm.sub": "Viele Dienste verlangen einen TXT-Eintrag als Nachweis, dass diese Domain Ihnen gehört.",
  "vm.svc": "Welcher Dienst?",
  "vm.token": "Verifizierungscode",
  "vm.token.placeholder": "Fügen Sie hier den Code aus der Google Search Console oder einem anderen Dienst ein",
  "vm.create": "TXT-Eintrag anlegen",
  "fwm.title": "Auf eine andere URL weiterleiten",
  "fwm.from": "Von (diese Domain)",
  "fwm.to": "Nach (vollständige URL)",
  "fwm.kind.full": "Ganze Domain",
  "fwm.kind.path": "Bestimmter Pfad",
  "fwm.kind.title": "Was möchten Sie weiterleiten?",
  "fwm.code": "Statuscode",
  "fwm.code.301": "301 — Dauerhaft (empfohlen)",
  "fwm.code.302": "302 — Vorübergehend",
  "fwm.create": "Weiterleitung anlegen",
  "rec.add.title": "DNS-Eintrag hinzufügen",
  "rec.edit.title": "DNS-Eintrag bearbeiten",
  "rec.type": "Typ",
  "rec.name": "Name",
  "rec.name.help": "Verwenden Sie @ für die Hauptdomain. Z. B. www, mail oder api.",
  "rec.value": "Wert",
  "rec.value.help.A": "Eine IPv4-Adresse, z. B. 185.182.56.42",
  "rec.value.help.AAAA": "Eine IPv6-Adresse, z. B. 2a01:7c8::1",
  "rec.value.help.CNAME": "Ein Hostname, auf den dieser Eintrag verweisen soll.",
  "rec.value.help.MX": "Priorität (niedriger = wichtiger), gefolgt vom Mailserver, z. B. 10 mail.dmrs.nl",
  "rec.value.help.TXT": "Freitext, oft für Verifizierung und E-Mail genutzt (SPF, DKIM, DMARC).",
  "rec.value.help.SRV": "Priorität, Gewichtung, Port und Ziel – z. B. 10 100 443 sip.example.com",
  "rec.ttl": "TTL (Sekunden)",
  "rec.ttl.help": "Wie lange andere Server diesen Eintrag zwischenspeichern dürfen. 3600 (1 Stunde) ist Standard.",
  "rec.prio": "Priorität",
  "rec.save": "Speichern",
  "rec.delete": "Eintrag löschen",
  "rec.delete.confirm": "Möchten Sie diesen Eintrag wirklich löschen?",
  "common.loading": "Wird geladen…",
  "format.justNow": "gerade eben",
  "format.perMonth": "{amount}/Monat",
  "invoiceStatus.paid": "Bezahlt",
  "invoiceStatus.open": "Offen",
  "invoiceStatus.overdue": "Überfällig",
  "invoiceStatus.failed": "Zahlung fehlgeschlagen",
  "invoiceStatus.cancelled": "Storniert",
  "hostingStatus.active": "Aktiv",
  "hostingStatus.suspended": "Gesperrt",
  "hostingStatus.terminated": "Beendet",
  "hostingStatus.pending": "Wird eingerichtet",
  "hostingStatus.pending_cancellation": "Gekündigt",
  "health.healthy": "Online",
  "health.degraded": "Beeinträchtigt",
  "health.down": "Offline",
  "health.unknown": "Aktiv",
  "health.checked": "Geprüft {time}",
  "notif.invoice.overdue": "Rechnung {number} ist überfällig",
  "notif.invoice.failed": "Zahlung für {number} fehlgeschlagen",
  "notif.invoice.open": "Rechnung {number} ist offen",
  "notif.invoice.body": "{amount} · fällig am {date}",
  "notif.hosting.suspended": "{domain} ist gesperrt",
  "notif.hosting.suspended.body": "Kontaktieren Sie uns oder begleichen Sie offene Rechnungen.",
  "notif.hosting.pending": "{domain} wird eingerichtet",
  "notif.hosting.pending.body": "Wir benachrichtigen Sie, sobald das Hosting bereitsteht.",
  "notif.hosting.down": "{domain} ist nicht erreichbar",
  "notif.hosting.down.body": "Wir kümmern uns darum. Details finden Sie beim Hosting.",
  "domainError.empty": "Geben Sie einen Domainnamen ein.",
  "domainError.url": "Geben Sie nur den Domainnamen ein, ohne http:// oder Pfad (z. B. beispiel.de).",
  "domainError.email": "Das sieht aus wie eine E-Mail-Adresse. Geben Sie nur den Domainnamen ein.",
  "domainError.space": "Ein Domainname darf keine Leerzeichen enthalten.",
  "domainError.www": "Lassen Sie „www.“ weg – das richten wir automatisch ein.",
  "domainError.no_tld": "Fügen Sie die Endung hinzu, zum Beispiel .de oder .com.",
  "domainError.too_long": "Dieser Domainname ist zu lang (maximal 253 Zeichen).",
  "domainError.empty_label": "Es stehen zwei Punkte hintereinander oder ein Punkt am Anfang.",
  "domainError.label_too_long": "Jeder Teil zwischen den Punkten darf höchstens 63 Zeichen lang sein.",
  "domainError.tld": "Diese Endung ist ungültig.",
  "domainError.chars": "Verwenden Sie nur Buchstaben, Ziffern und Bindestriche.",
  "domainError.hyphen": "Ein Domainname darf nicht mit einem Bindestrich beginnen oder enden.",
  "lang.label": "Sprache",
  "domainsPage.loadError": "Domains konnten nicht geladen werden",
  "domainsPage.notFound": "Domain nicht gefunden",
  "domainsPage.search": "Domain suchen…",
  "domainsPage.filter.pending": "In Bearbeitung",
  "domainsPage.dnsPick.title": "DNS-Eintrag hinzufügen",
  "domainsPage.dnsPick.none": "Sie haben noch keine Domains. Fügen Sie zuerst eine Domain hinzu.",
  "domainsPage.dnsPick.choose": "Wählen Sie unten die Domain, für die Sie einen Eintrag hinzufügen möchten.",
  "domainsPage.dismiss": "Schließen",
  "domainsPage.empty": "Keine Domains gefunden.",
  "domainsPage.notLinked": "Nicht verknüpft",
  "domainsPage.autoRenew.on": "Automatische Verlängerung an",
  "domainsPage.autoRenew.off": "Automatische Verlängerung aus",
  "domainsPage.status.active": "Aktiv",
  "domainsPage.status.pending": "In Bearbeitung",
  "domainsPage.status.transferring": "Wird übertragen",
  "domainsPage.status.expired": "Abgelaufen",
  "domainsPage.status.suspended": "Gesperrt",
  "domainsPage.status.cancelled": "Storniert",
  "domainsPage.status.unknown": "Unbekannt",
  "domainsPage.days.expired": "abgelaufen",
  "domainsPage.days.today": "heute",
  "domainsPage.days.one": "in 1 Tag",
  "domainsPage.days.other": "in {n} Tagen",
  "addDomain.duplicate": "Diese Domain ist bereits in Ihrem Konto.",
  "addDomain.requested": "{domain} wurde beantragt",
  "addDomain.exists": "Diese Domain ist in unserem System bereits registriert.",
  "addDomain.confirm.title": "Registrierung bestätigen",
  "addDomain.confirm.description": "Prüfen Sie die Angaben. Nach der Bestätigung wird die Registrierung beantragt.",
  "addDomain.back": "Zurück",
  "addDomain.working": "Wird ausgeführt…",
  "addDomain.register": "Domain registrieren",
  "addDomain.term": "Laufzeit",
  "addDomain.cost": "Kosten",
  "addDomain.cost.value": "Zum aktuellen Tarif für {tld}; der Betrag erscheint auf Ihrer nächsten Rechnung.",
  "addDomain.next": "Weiter",
  "addDomain.name": "Domainname",
  "addDomain.name.hint": "Der vollständige Domainname inklusive Endung (.de, .com, .eu, …).",
  "addDomain.name.placeholder": "beispiel.de",
  "emailList.domains.one": "{n} Domain",
  "emailList.domains.other": "{n} Domains",
  "emailList.kpi.allocated": "insgesamt zugewiesen",
  "emailList.kpi.noMetric": "Keine Messung",
  "emailList.search": "Postfach suchen…",
  "emailList.group.byDomain": "Nach Domain",
  "emailList.group.flat": "Alle",
  "emailList.loadError": "Postfächer konnten nicht geladen werden",
  "emailList.empty.title": "Noch keine Postfächer",
  "emailList.empty.body": "Legen Sie Ihr erstes Postfach an.",
  "emailList.noResults.title": "Keine Postfächer gefunden",
  "emailList.noResults.body": "Passen Sie Ihre Suche oder den Filter an.",
  "emailList.addresses.one": "{n} Adresse",
  "emailList.addresses.other": "{n} Adressen",
  "emailList.status.suspended": "Gesperrt",
  "emailList.status.pending": "In Bearbeitung",
  "emailList.status.disabled": "Deaktiviert",
  "emailList.new.localError": "Verwenden Sie vor dem @ nur Buchstaben, Ziffern und . _ - + (nicht am Anfang oder Ende).",
  "mailDomain.add": "E-Mail-Domain hinzufügen",
  "mailDomain.description": "Wählen Sie eine Domain oder ein Hostingpaket Ihres Kontos. Wir richten den Mailserver und die DNS-Einträge (MX, SPF, DKIM, DMARC) für Sie ein.",
  "mailDomain.activate": "E-Mail aktivieren",
  "mailDomain.stop": "E-Mail deaktivieren",
  "mailDomain.stopHint": "Deaktivieren Sie die E-Mail bei uns, um zu einem anderen Mailanbieter zu wechseln.",
  "mailDomain.stopTitle": "E-Mail für {domain} deaktivieren?",
  "mailDomain.stopBody": "Alle {n} Postfächer, Aliasse und ihre Nachrichten werden endgültig gelöscht, und die Mail-Einträge (MX, SPF, DKIM) werden aus dem DNS entfernt. Dies kann nicht rückgängig gemacht werden.",
  "mailDomain.stopped": "E-Mail für {domain} wurde deaktiviert.",
  "mailDomain.activated": "E-Mail für {domain} aktiviert",
  "mailDomain.none": "Alle Domains haben bereits E-Mail. Fügen Sie zuerst eine Domain oder ein Hostingpaket hinzu.",
  "mailDomain.firstActivate": "Sie haben noch keine E-Mail-Domain.",
  "mailDomain.routingHint": "Möchten Sie Postfächer für diese Domain bei uns? Aktivieren Sie E-Mail, dann richten wir den Mailserver und die DNS-Einträge ein.",
  "mailDomain.err.notOwned": "Diese Domain gehört nicht zu Ihrem Konto. Fügen Sie zuerst die Domain oder ein Hostingpaket dafür hinzu.",
  "mailDomain.err.exists": "Für diese Domain ist E-Mail bereits aktiv.",
  "emailList.new.chooseDomain": "— Domain wählen —",
  "emailList.new.username": "Benutzername (vor dem @)",
  "emailList.new.quota": "Speicherkontingent (MB)",
  "emailDetail.working": "Wird ausgeführt…",
  "emailDetail.create": "Erstellen",
  "emailDetail.delete": "Löschen",
  "emailDetail.change": "Ändern",
  "emailDetail.off": "Aus",
  "emailDetail.notFound": "Postfach nicht gefunden",
  "emailDetail.quota": "Speicherplatz",
  "emailDetail.forward.keepCopy": "{address} (Kopie behalten)",
  "emailDetail.client.title": "Einstellungen für Ihr E-Mail-Programm",
  "emailDetail.client.unavailable": "Für diese Domain sind noch keine Serverdaten verfügbar.",
  "emailDetail.pw.min": "Mindestens 12 Zeichen.",
  "emailDetail.pw.mismatch": "Die Passwörter stimmen nicht überein.",
  "emailDetail.forward.saved": "Weiterleitung gespeichert",
  "emailDetail.forward.desc": "Leiten Sie eingehende E-Mails an eine andere Adresse weiter.",
  "emailDetail.forward.on": "Weiterleitung an",
  "emailDetail.forward.to": "Weiterleiten an",
  "emailDetail.invalidEmail": "Keine gültige E-Mail-Adresse.",
  "emailDetail.forward.placeholder": "name@beispiel.de",
  "emailDetail.forward.keep": "Kopie in diesem Postfach behalten",
  "emailDetail.vacation.defaultSubject": "Abwesend",
  "emailDetail.vacation.saved": "Abwesenheitsnotiz gespeichert",
  "emailDetail.vacation.title": "Abwesenheitsnotiz",
  "emailDetail.vacation.desc": "Senden Sie während Urlaub oder Abwesenheit automatisch eine Antwort.",
  "emailDetail.vacation.on": "Abwesenheitsnotiz an",
  "emailDetail.vacation.placeholder": "Zum Beispiel: Ich bin bis einschließlich Montag abwesend und antworte danach so schnell wie möglich.",
  "emailDetail.aliases.desc": "Zusätzliche Adressen, die in dieses Postfach zustellen.",
  "emailDetail.aliases.empty.title": "Noch keine Aliasse",
  "emailDetail.aliases.empty.body": "Legen Sie z. B. info@ oder kontakt@ als Alias für dieses Postfach an.",
  "emailDetail.aliases.deleteAria": "{address} löschen",
  "emailDetail.aliases.added": "Alias hinzugefügt",
  "emailDetail.aliases.deleted": "Alias gelöscht",
  "emailDetail.aliases.confirmTitle": "Alias löschen?",
  "emailDetail.aliases.confirmBody": "E-Mails an {address} werden danach nicht mehr zugestellt.",
  "emailDetail.aliasModal.deliversTo": "Eingehende E-Mails werden an {address} zugestellt",
  "emailDetail.aliasModal.label": "Alias (Teil vor dem @)",
  "emailDetail.aliasModal.name": "name",
  "emailDetail.aliasModal.invalid": "Nur Buchstaben, Ziffern und . _ + -",
  "emailDetail.quota.saved": "Speicherplatz angepasst",
  "emailDetail.quota.title": "Speicherplatz",
  "emailDetail.quota.desc": "Maximaler Speicherplatz für dieses Postfach.",
  "emailDetail.danger.title": "Gefahrenbereich",
  "emailDetail.danger.desc": "Das Löschen eines Postfachs ist endgültig. Alle E-Mails und Einstellungen gehen verloren.",
  "emailDetail.danger.confirmBody": "Möchten Sie {address} wirklich endgültig löschen?",
  "emailDetail.deleted": "Postfach gelöscht",
  "emailDetail.spam.saved": "Spamfilter gespeichert",
  "emailDetail.spam.lenient": "Locker",
  "emailDetail.spam.desc": "Wie streng soll der Spamfilter sein?",
  "dashboard.greeting.night": "Gute Nacht",
  "dashboard.greeting.night.named": "Gute Nacht, {name}",
  "dashboard.greeting.morning": "Guten Morgen",
  "dashboard.greeting.morning.named": "Guten Morgen, {name}",
  "dashboard.greeting.afternoon": "Guten Tag",
  "dashboard.greeting.afternoon.named": "Guten Tag, {name}",
  "dashboard.greeting.evening": "Guten Abend",
  "dashboard.greeting.evening.named": "Guten Abend, {name}",
  "dashboard.sites.error": "Ihre Websites konnten nicht geladen werden",
  "dashboard.sites.empty": "Noch kein Hosting",
  "dashboard.sites.empty.body": "Bestellen Sie ein Hosting-Paket, um loszulegen.",
  "dashboard.usage.none": "Noch keine Messung",
  "dashboard.activity.empty": "Noch keine Aktivität.",
  "detailUi.working": "Wird ausgeführt…",
  "detailUi.notFound": "Nicht gefunden",
  "detailUi.loadFailed": "Laden fehlgeschlagen",
  "detailUi.retry": "Erneut versuchen",
  "newPlan.title": "Neues Hosting-Paket",
  "newPlan.description": "Wählen Sie ein Paket und verknüpfen Sie eine Domain.",
  "newPlan.created": "Hosting erstellt",
  "newPlan.create": "Erstellen",
  "newPlan.packages.error": "Pakete konnten nicht geladen werden. {error}",
  "newPlan.domain.placeholder": "beispiel.de",
  "newPlan.package": "Paket",
  "newPlan.packages.loading": "Pakete werden geladen…",
  "newPlan.package.choose": "— Paket wählen —",
  "hostingList.onServers.one": "auf {n} Server",
  "hostingList.onServers.other": "auf {n} Servern",
  "hostingList.storage.allocated": "insgesamt zugewiesen",
  "hostingList.traffic.none": "keine Messung",
  "hostingList.error": "Hosting konnte nicht geladen werden",
  "hostingList.empty": "Kein Hosting",
  "hostingList.empty.body": "Fügen Sie Ihr erstes Paket hinzu, um loszulegen.",
  "hostingList.servers.none": "Keine Serverinformationen verfügbar.",
  "hostingList.sites.one": "{n} Website",
  "hostingList.sites.other": "{n} Websites",
  "hostingList.addPlanFirst": "Fügen Sie zuerst ein Paket hinzu",
  "hostingList.serverStatus.online": "Online",
  "hostingList.serverStatus.offline": "Offline",
  "hostingList.serverStatus.provisioning": "Wird eingerichtet",
  "hostingList.serverStatus.error": "Störung",
  "hostingDetail.notFound": "Hosting nicht gefunden",
  "hostingDetail.tab.access": "SFTP-Zugang",
  "hostingDetail.ssl.settingUp": "SSL wird eingerichtet",
  "hostingDetail.price": "Preis",
  "hostingDetail.storage": "Speicher",
  "hostingDetail.memory": "Arbeitsspeicher",
  "hostingDetail.runtime": "Laufzeitumgebung",
  "hostingDetail.addons": "Add-ons",
  "hostingDetail.created": "Erstellt",
  "hostingDetail.nextInvoice": "Nächste Rechnung",
  "hostingDetail.lastChanged": "Zuletzt geändert",
  "hostingDetail.ssl.provider": "Anbieter",
  "hostingDetail.ssl.status": "Status",
  "hostingDetail.ssl.active": "Aktiv",
  "hostingDetail.ssl.inactive": "Nicht aktiv",
  "hostingDetail.ssl.enable": "SSL aktivieren",
  "hostingDetail.ssl.selfsigned": "Vorläufiges Zertifikat",
  "hostingDetail.ssl.temporary": "Vorläufig — Browser zeigen eine Warnung",
  "hostingDetail.ssl.selfsignedHint": "Sobald Ihre Domain auf diesen Server zeigt, installieren wir automatisch ein kostenloses Let's-Encrypt-Zertifikat.",
  "hostingDetail.copied": "Kopiert",
  "hostingDetail.copyFailed": "Kopieren fehlgeschlagen",
  "hostingDetail.copy": "Kopieren",
  "hostingDetail.protocol": "Protokoll",
  "hostingDetail.sftp.users": "SFTP-Benutzer",
  "hostingDetail.sftp.addUser": "Benutzer hinzufügen",
  "hostingDetail.sftp.limit": "Ihr Paket hat das Maximum von {max} SFTP-Benutzer(n) erreicht.",
  "hostingDetail.sftp.empty": "Noch keine SFTP-Benutzer.",
  "hostingDetail.sftp.noServer": "Diesem Hosting ist noch kein Server zugewiesen. SFTP ist verfügbar, sobald es eingerichtet ist.",
  "hostingDetail.sftp.createdOn": "Erstellt am {date}",
  "hostingDetail.sftp.newPassword": "Neues Passwort",
  "hostingDetail.delete": "Löschen",
  "hostingDetail.sftp.deleteUser": "{name} löschen",
  "hostingDetail.sftp.reset.title": "Neues Passwort generieren?",
  "hostingDetail.sftp.reset.body": "Das aktuelle Passwort von {name} funktioniert danach nicht mehr.",
  "hostingDetail.sftp.reset.cta": "Generieren",
  "hostingDetail.sftp.delete.title": "SFTP-Benutzer löschen?",
  "hostingDetail.sftp.delete.body": "{name} kann sich danach nicht mehr anmelden.",
  "hostingDetail.sftp.deleted": "Benutzer gelöscht",
  "hostingDetail.sftp.add.title": "SFTP-Benutzer hinzufügen",
  "hostingDetail.sftp.add.description": "Das Passwort wird nach dem Erstellen einmalig angezeigt.",
  "hostingDetail.sftp.add.username": "Benutzername (optional)",
  "hostingDetail.sftp.add.usernameHint": "Kleinbuchstaben, Ziffern, - und _. Leer lassen für einen automatischen Namen.",
  "hostingDetail.sftp.add.invalid": "Ungültiger Benutzername.",
  "hostingDetail.secret.title": "Bewahren Sie dieses Passwort auf",
  "hostingDetail.secret.description": "Es wird nur einmal angezeigt.",
  "hostingDetail.secret.done": "Ich habe es gespeichert",
  "hostingDetail.user": "Benutzer",
  "hostingDetail.db.adminer": "Adminer öffnen",
  "hostingDetail.db.none": "Dieses Paket enthält keine Datenbank.",
  "hostingDetail.db.type": "Typ",
  "hostingDetail.db.database": "Datenbank",
  "hostingDetail.db.host": "Host (von Ihrer Website aus)",
  "hostingDetail.db.password": "Passwort",
  "hostingDetail.hide": "Ausblenden",
  "hostingDetail.show": "Anzeigen",
  "hostingDetail.runtime.current": "Aktuelle Laufzeitumgebung",
  "hostingDetail.runtime.change": "Sie benötigen eine andere Version? Wenden Sie sich an den Support – wir stellen sie für Sie um.",
  "hostingDetail.cancel.pendingUntil": "Gekündigt. Das Hosting läuft bis zum {date} weiter.",
  "hostingDetail.cancel.pendingEndOfPeriod": "Gekündigt. Das Hosting läuft bis zum Ende des Zeitraums weiter.",
  "hostingDetail.cancel.info": "Die Kündigung wird zum Ende des laufenden Zeitraums wirksam. Danach werden alle Dateien gelöscht.",
  "hostingDetail.revoke.button": "Kündigung zurückziehen",
  "hostingDetail.restart.title": "Hosting neu starten?",
  "hostingDetail.restart.started": "Neustart gestartet",
  "hostingDetail.cancel.title": "Hosting kündigen?",
  "hostingDetail.cancel.body": "Möchten Sie {domain} wirklich kündigen?",
  "hostingDetail.cancel.submitted": "Kündigung eingereicht",
  "hostingDetail.revoke.title": "Kündigung zurückziehen?",
  "hostingDetail.revoke.body": "Das Hosting läuft dann einfach weiter.",
  "hostingDetail.revoke.cta": "Zurückziehen",
  "hostingDetail.revoke.done": "Kündigung zurückgezogen",
  "billingPage.noPaymentLink": "Kein Zahlungslink erhalten. Bitte versuchen Sie es später erneut.",
  "billingPage.mandate.loadFailed": "konnte nicht geladen werden",
  "billingPage.mandate.none": "nicht eingerichtet",
  "billingPage.openCount.one": "{n} Rechnung",
  "billingPage.openCount.other": "{n} Rechnungen",
  "billingPage.allPaid": "alles bezahlt",
  "billingPage.inclVat": "inkl. MwSt.",
  "billingPage.next.approx": "ca. {amount}",
  "billingPage.next.none": "keine laufenden Abonnements",
  "billingPage.sepa.enabled": "SEPA-Lastschrift ist aktiv",
  "billingPage.sepa.body": "Rechnungen werden am Fälligkeitsdatum automatisch abgebucht.",
  "billingPage.revoke.cta": "Mandat widerrufen",
  "billingPage.noInvoices": "Keine Rechnungen.",
  "billingPage.renews": "verlängert sich am {date}",
  "billingPage.noSubscriptions": "Keine Abonnements.",
  "billingPage.add": "Hinzufügen",
  "billingPage.method.loadFailed": "Ihre Zahlungsmethode konnte nicht abgerufen werden.",
  "billingPage.retry": "Erneut versuchen",
  "billingPage.method.none": "Keine Zahlungsmethode eingerichtet.",
  "billingPage.mandateStatus.valid": "aktiv",
  "billingPage.mandateStatus.pending": "in Bearbeitung",
  "billingPage.mandateStatus.invalid": "ungültig",
  "billingPage.mandateStatus.revoked": "widerrufen",
  "billingPage.revoke.done": "Mandat widerrufen",
  "billingPage.revoke.title": "SEPA-Lastschriftmandat widerrufen?",
  "billingPage.revoke.body": "Rechnungen werden danach nicht mehr automatisch abgebucht. Sie bezahlen sie dann selbst über die Rechnungsseite.",
  "billingPage.working": "Wird ausgeführt…",
  "billingPage.revoke.confirm": "Widerrufen",
  "billingDetail.notFound": "Rechnung nicht gefunden",
  "billingDetail.loadFailed": "Rechnung konnte nicht geladen werden",
  "billingDetail.notFound.body": "Diese Rechnung existiert nicht oder gehört nicht zu Ihrem Konto.",
  "billingDetail.downloadFailed": "Download fehlgeschlagen",
  "billingDetail.title": "Rechnung {number}",
  "billingDetail.due": "Fällig am {date}",
  "billingDetail.print": "Drucken",
  "billingDetail.payNow": "Jetzt bezahlen",
  "billingDetail.items": "Positionen",
  "billingDetail.hostingPlan": "Hosting {plan}",
  "billingDetail.hostingId": "Hosting #{id}",
  "billingDetail.services": "Leistungen",
  "billingDetail.invoiceDate": "Rechnungsdatum",
  "billingDetail.vat": "MwSt.",
  "billingDetail.vatPct": "MwSt. ({pct} %)",
  "billingDetail.pdfNote": "Die vollständige Aufstellung finden Sie im PDF.",
  "billingDetail.billedTo": "Rechnungsempfänger",
  "billingDetail.addressNote": "Die vollständige Rechnungsadresse steht im PDF. Stimmt etwas nicht? Kontaktieren Sie uns.",
  "billingDetail.history": "Verlauf",
  "billingDetail.hist.created": "Rechnung erstellt",
  "billingDetail.hist.overdue": "Fälligkeitsdatum überschritten",
  "billingDetail.hist.cancelled": "Rechnung storniert",
  "billingDetail.hist.paid": "Zahlung eingegangen",
  "billingDetail.pay.title": "Rechnung bezahlen",
  "billingDetail.pay.cta": "Weiter zur Zahlung",
  "billingDetail.pay.choose": "Wählen Sie eine Zahlungsmethode",
  "billingDetail.method.any": "Auf der Zahlungsseite wählen",
  "billingDetail.method.any.sub": "Alle verfügbaren Zahlungsmethoden",
  "billingDetail.method.ideal": "iDEAL",
  "billingDetail.method.ideal.sub": "Direkt über Ihre Bank bezahlen",
  "billingDetail.method.creditcard": "Kreditkarte",
  "billingDetail.method.creditcard.sub": "Mastercard / Visa / Amex",
  "backupsPage.automatic": "Automatisch",
  "backupsPage.kpi.lastSub": "letztes erfolgreiches Backup",
  "backupsPage.kpi.lastNone": "noch keine Backups",
  "backupsPage.kpi.successSub": "der abgeschlossenen Backups erfolgreich",
  "backupsPage.kpi.storageSub": "gesamt in aufbewahrten Backups",
  "backupsPage.days.one": "{n} Tag",
  "backupsPage.days.other": "{n} Tage",
  "backupsPage.kpi.retentionSub": "maximal",
  "backupsPage.noHostings": "Keine Hostings gefunden.",
  "backupsPage.every": "Alle {h} Std.",
  "backupsPage.failed": "Fehlgeschlagen",
  "backupsPage.noBackup": "Noch kein Backup",
  "backupsPage.off": "Aus",
  "backupsDetail.notFound": "Hosting nicht gefunden",
  "backupsDetail.autoOff": "Automatische Backups aus",
  "backupsDetail.lastFailed": "Letztes Backup fehlgeschlagen",
  "backupsDetail.snapshots.one": "{n} Snapshot",
  "backupsDetail.snapshots.other": "{n} Snapshots",
  "backupsDetail.last": "zuletzt {time}",
  "backupsDetail.onlyActive": "Nur für aktive Hostings",
  "backupsDetail.running": "Backup läuft…",
  "backupsDetail.tab.schedule": "Zeitplan",
  "backupsDetail.create.title": "Jetzt ein Backup erstellen?",
  "backupsDetail.create.body": "Das Backup läuft im Hintergrund und kann einige Minuten dauern.",
  "backupsDetail.create.cta": "Backup starten",
  "backupsDetail.create.done": "Backup gestartet",
  "backupsDetail.restore.title": "Backup wiederherstellen?",
  "backupsDetail.restore.body": "Die aktuellen Dateien und die Datenbank von {domain} werden durch das Backup vom {date} ersetzt. Dies kann nicht rückgängig gemacht werden.",
  "backupsDetail.restore.cta": "Wiederherstellen",
  "backupsDetail.restore.done": "Wiederherstellung gestartet",
  "backupsDetail.pickSnapshot": "Wählen Sie einen abgeschlossenen Snapshot zum Wiederherstellen.",
  "backupsDetail.empty.title": "Noch keine Backups",
  "backupsDetail.empty.body": "Das erste automatische Backup erscheint hier, sobald es erstellt wurde.",
  "backupsDetail.col.time": "Zeitpunkt",
  "backupsDetail.col.keptUntil": "Aufbewahrt bis",
  "backupsDetail.type.full": "Automatisch",
  "backupsDetail.type.incremental": "Inkrementell",
  "backupsDetail.type.manual": "Manuell",
  "backupsDetail.status.pending": "In Warteschlange",
  "backupsDetail.status.running": "Läuft",
  "backupsDetail.status.completed": "Abgeschlossen",
  "backupsDetail.status.failed": "Fehlgeschlagen",
  "backupsDetail.saved": "Backup-Zeitplan gespeichert",
  "backupsDetail.auto.title": "Automatische Backups",
  "backupsDetail.auto.toggle": "Backups automatisch erstellen",
  "backupsDetail.frequency": "Häufigkeit",
  "backupsDetail.everyHours": "Alle {n} Stunden",
  "backupsDetail.keepFor": "Aufbewahren",
  "backupsDetail.retention": "Aufbewahrungsdauer",
  "backupsDetail.working": "Wird ausgeführt…",
  "dashboard.activity.verb.create": "{resource} erstellt",
  "dashboard.activity.verb.update": "{resource} geändert",
  "dashboard.activity.verb.delete": "{resource} gelöscht",
  "dashboard.activity.verb.restore": "{resource} wiederhergestellt",
  "dashboard.activity.verb.suspend": "{resource} gesperrt",
  "dashboard.activity.verb.unsuspend": "{resource} reaktiviert",
  "dashboard.activity.verb.register": "{resource} registriert",
  "dashboard.activity.verb.cancel": "{resource} gekündigt",
  "dashboard.activity.verb.renew": "{resource} verlängert",
  "dashboard.activity.verb.pay": "{resource} bezahlt",
  "dashboard.activity.resource.hosting": "Hosting",
  "dashboard.activity.resource.backup": "Backup",
  "dashboard.activity.resource.domain": "Domain",
  "dashboard.activity.resource.dns": "DNS-Eintrag",
  "dashboard.activity.resource.email": "E-Mail",
  "dashboard.activity.resource.invoice": "Rechnung",
  "dashboard.activity.resource.payment": "Zahlung",
  "dashboard.activity.resource.user": "Konto",
  "dashboard.activity.resource.server": "Server",
  "dashboard.activity.resource.package": "Paket",
  "domainDetail.allDomains": "Alle Domains",
  "domainDetail.expiresIn.one": " · in {n} Tag",
  "domainDetail.expiresIn.other": " · in {n} Tagen",
  "domainDetail.autoRenewState.on": "Automatische Verlängerung: an",
  "domainDetail.autoRenewState.off": "Automatische Verlängerung: aus",
  "domainDetail.status.active": "Aktiv",
  "domainDetail.status.pending": "In Bearbeitung",
  "domainDetail.status.transferring": "Wird übertragen",
  "domainDetail.status.expired": "Abgelaufen",
  "domainDetail.status.suspended": "Gesperrt",
  "domainDetail.status.unknown": "Unbekannt",
  "domainDetail.registration": "Registrierung",
  "domainDetail.autoRenew": "Automatische Verlängerung",
  "domainDetail.on": "An",
  "domainDetail.off": "Aus",
  "domainDetail.nameservers": "Nameserver",
  "domainDetail.linkedServices": "Verknüpfte Dienste",
  "domainDetail.webHosting": "Webhosting",
  "domainDetail.emailService.one": "E-Mail ({n} Postfach)",
  "domainDetail.emailService.other": "E-Mail ({n} Postfächer)",
  "domainDetail.notLinked": "Diese Domain ist noch nicht mit Hosting oder E-Mail verknüpft.",
  "domainDetail.openService": "{name} öffnen",
  "domainDetail.dns.simpleTitle": "Was möchten Sie tun?",
  "domainDetail.dns.allRecords": "Alle DNS-Einträge",
  "domainDetail.dns.simpleSub": "Wählen Sie eine häufige Aufgabe – wir richten die DNS-Einträge für Sie ein.",
  "domainDetail.dns.advancedSub": "Unsicher? Verwenden Sie den einfachen Modus.",
  "domainDetail.dns.mode": "DNS-Modus",
  "domainDetail.dns.simple": "Einfach",
  "domainDetail.dns.advanced": "Erweitert",
  "domainDetail.task.website.desc": "Richten Sie A- und CNAME-Einträge ein, damit Besucher Ihre Website erreichen.",
  "domainDetail.task.mail.title": "Meine E-Mail läuft über…",
  "domainDetail.task.mail.desc": "Konfigurieren Sie MX-Einträge für Ihren E-Mail-Anbieter.",
  "domainDetail.task.verify.title": "Dienst verifizieren",
  "domainDetail.task.verify.desc": "Legen Sie einen TXT-Eintrag an, um die Inhaberschaft nachzuweisen (Google, Meta, …).",
  "domainDetail.task.forward.title": "Auf eine andere URL weiterleiten",
  "domainDetail.task.forward.desc": "Leiten Sie Besucher dieser Domain an eine andere Adresse weiter.",
  "domainDetail.records.one": "{n} Eintrag",
  "domainDetail.records.other": "{n} Einträge",
  "domainDetail.addRecord": "Eintrag hinzufügen",
  "domainDetail.noRecords": "Noch keine DNS-Einträge",
  "domainDetail.noRecords.sub": "Fügen Sie einen Eintrag hinzu oder verwenden Sie den einfachen Modus.",
  "domainDetail.col.type": "Typ",
  "domainDetail.name": "Name",
  "domainDetail.edit": "Bearbeiten",
  "domainDetail.editRecord": "{type} {name} bearbeiten",
  "domainDetail.err.value": "Geben Sie einen Wert ein.",
  "domainDetail.err.ipv4": "Keine gültige IPv4-Adresse.",
  "domainDetail.err.ipv6": "Keine gültige IPv6-Adresse.",
  "domainDetail.err.hostname": "Kein gültiger Hostname.",
  "domainDetail.err.priority": "Geben Sie eine Priorität ein.",
  "domainDetail.recordAdded": "Eintrag hinzugefügt",
  "domainDetail.recordSaved": "Eintrag gespeichert",
  "domainDetail.deleteRecord.title": "Eintrag löschen?",
  "domainDetail.delete": "Löschen",
  "domainDetail.recordDeleted": "Eintrag gelöscht",
  "domainDetail.addDnsRecord": "DNS-Eintrag hinzufügen",
  "domainDetail.editDnsRecord": "DNS-Eintrag bearbeiten",
  "domainDetail.propagation": "Es kann bis zu 1 Stunde dauern, bis Änderungen weltweit sichtbar sind.",
  "domainDetail.working": "Wird ausgeführt…",
  "domainDetail.typeFixed": "Der Typ kann nicht geändert werden.",
  "domainDetail.ttlSeconds": "TTL (Sekunden)",
  "domainDetail.name.hint": "Verwenden Sie @ für {domain} oder z. B. www oder mail.",
  "domainDetail.err.name": "Geben Sie einen Namen ein.",
  "domainDetail.priority.hint": "Niedriger = wichtiger.",
  "domainDetail.replaced.one": "{n} vorhandener Eintrag wird ersetzt.",
  "domainDetail.replaced.other": "{n} vorhandene Einträge werden ersetzt.",
  "domainDetail.website.desc": "Wählen Sie, wo Ihre Website läuft. Wir setzen die passenden DNS-Einträge.",
  "domainDetail.recordsApplied": "Einträge übernommen",
  "domainDetail.website.where": "Wo läuft Ihre Website?",
  "domainDetail.website.ip": "Eine IP-Adresse",
  "domainDetail.website.ip.sub": "Ihr Hosting-Anbieter gibt Ihnen eine IPv4-Adresse.",
  "domainDetail.website.host": "Ein Hostname (z. B. meineseite.netlify.app)",
  "domainDetail.website.host.sub": "Für Dienste wie Netlify, Vercel oder Shopify. Gilt für www.",
  "domainDetail.ipAddress": "IP-Adresse",
  "domainDetail.hostname": "Hostname",
  "domainDetail.preview.set": "Wir setzen diese Einträge:",
  "domainDetail.mail.ours": "Unser E-Mail-Dienst",
  "domainDetail.mail.ours.desc": "Postfächer verwalten Sie hier im Portal ({n} aktiv).",
  "domainDetail.mail.google.desc": "Gmail für Ihre Domain. Erfordert ein Workspace-Konto.",
  "domainDetail.mail.ms.desc": "Outlook für Ihre Domain. Erfordert ein Microsoft-365-Konto.",
  "domainDetail.mail.custom": "Anderer Anbieter",
  "domainDetail.mail.custom.desc": "Geben Sie den Mailserver Ihres Anbieters ein.",
  "domainDetail.mail.none": "Keine E-Mail",
  "domainDetail.mail.none.desc": "Keine E-Mail für diese Domain. Entfernt die MX-Einträge.",
  "domainDetail.mail.desc": "Wählen Sie Ihren E-Mail-Anbieter. Wir ersetzen die MX-Einträge.",
  "domainDetail.mail.cta": "MX-Einträge ersetzen",
  "domainDetail.mail.applied": "MX-Einträge übernommen",
  "domainDetail.mail.provider": "E-Mail-Anbieter",
  "domainDetail.mail.server": "Mailserver",
  "domainDetail.preview.mxRemoved": "Alle MX-Einträge werden entfernt.",
  "domainDetail.verify.desc": "Viele Dienste verlangen einen TXT-Eintrag als Nachweis, dass diese Domain Ihnen gehört.",
  "domainDetail.verify.cta": "TXT-Eintrag anlegen",
  "domainDetail.verify.created": "TXT-Eintrag angelegt",
  "domainDetail.verify.code": "Verifizierungscode",
  "domainDetail.verify.code.hint": "Beginnt meist z. B. mit google-site-verification=",
  "domainDetail.preview.create": "Wir legen diesen Eintrag an:",
  "domainDetail.redirect.desc": "Besucher werden automatisch an die von Ihnen eingegebene Adresse weitergeleitet.",
  "domainDetail.create": "Anlegen",
  "domainDetail.redirect.created": "Weiterleitung angelegt",
  "domainDetail.redirect.from": "Von",
  "domainDetail.redirect.from.hint": "@ für {domain} oder eine Subdomain wie shop.",
  "domainDetail.redirect.from.err": "Verwenden Sie @ oder eine gültige Subdomain.",
  "domainDetail.redirect.to": "Nach (vollständige URL)",
  "domainDetail.redirect.to.err": "Geben Sie eine vollständige URL ein, beginnend mit https://",
  "domainDetail.redirect.type": "Art der Weiterleitung",
  "domainDetail.redirect.301": "301 — dauerhaft",
  "domainDetail.redirect.302": "302 — vorübergehend",
  "domainDetail.redirect.keepPath": "Pfad beibehalten (/seite → ziel/seite)",
  "domainDetail.routing.title": "Aktuelles Mail-Routing",
  "domainDetail.routing.change": "Anbieter ändern",
  "domainDetail.routing.none": "Keine E-Mail eingerichtet",
  "domainDetail.routing.noMx": "Für diese Domain gibt es keine MX-Einträge.",
  "domainDetail.deliverability": "Zustellbarkeit",
  "domainDetail.spf.missing": "Kein SPF-Eintrag gefunden. Empfänger könnten Ihre E-Mails als Spam einstufen.",
  "domainDetail.dkim.missing": "Kein DKIM-Eintrag gefunden.",
  "domainDetail.dmarc.policy": "Richtlinie: {policy}",
  "domainDetail.dmarc.missing": "Kein DMARC-Eintrag gefunden. Empfohlen: p=quarantine.",
  "domainDetail.forwards": "Weiterleitungen",
  "domainDetail.add": "Hinzufügen",
  "domainDetail.forwards.empty": "Keine Weiterleitungen",
  "domainDetail.forwards.empty.sub": "Leiten Sie diese Domain (oder eine Subdomain davon) an eine andere Adresse weiter.",
  "domainDetail.forward.temporary": "Vorübergehend",
  "domainDetail.forward.permanent": "Dauerhaft",
  "domainDetail.forward.frame": "Frame",
  "domainDetail.forward.delete": "Weiterleitung {from} löschen",
  "domainDetail.forward.delete.title": "Weiterleitung löschen?",
  "domainDetail.forward.deleted": "Weiterleitung gelöscht",
  "domainDetail.ns.saved": "Nameserver gespeichert",
  "domainDetail.ns.desc": "Die Nameserver bestimmen, wer das DNS dieser Domain verwaltet. Wählen Sie unsere Nameserver (wir verwalten die Zone) oder Ihre eigenen.",
  "domainDetail.ns.label": "Nameserver {n}",
  "domainDetail.ns.invalid": "Mindestens ein Nameserver ist kein gültiger Hostname.",
  "domainDetail.dnssec.enabled": "DNSSEC aktiviert",
  "domainDetail.dnssec.disabled": "DNSSEC deaktiviert",
  "domainDetail.dnssec.desc": "DNSSEC signiert DNS-Antworten kryptografisch. Empfohlen für Produktivdomains.",
  "domainDetail.dnssec.changed": "Geändert am {date}",
  "topbar.search.goToPage": "Zur Seite",
  "topbar.search.action": "Aktion",
  "topbar.action.addDomain": "Domain hinzufügen",
  "topbar.action.createMailbox": "Postfach anlegen",
  "topbar.action.addDnsRecord": "DNS-Eintrag hinzufügen",
  "topbar.action.restoreBackup": "Backup wiederherstellen",
  "topbar.action.newPlan": "Neues Hosting-Paket",
  "topbar.action.openInvoices": "Offene Rechnungen",
  "topbar.menu.open": "Menü öffnen",
  "topbar.menu.close": "Menü schließen",
  "topbar.menu.label": "Menü",
  "topbar.menu.main": "Hauptmenü",
  "topbar.search.title": "Suchen (⌘K)",
  "topbar.search.label": "Suchen",
  "topbar.search.placeholder": "Suchen…",
  "topbar.search.pages": "Seiten",
  "topbar.search.actions": "Aktionen",
  "topbar.search.inputLabel": "Seite oder Aktion suchen",
  "topbar.search.inputPlaceholder": "Seite oder Aktion suchen…",
  "topbar.search.noResults": "Keine Ergebnisse für „{q}“",
  "topbar.search.navigate": "navigieren",
  "topbar.search.open": "öffnen",
  "topbar.search.close": "schließen",
  "topbar.notif.title": "Benachrichtigungen",
  "topbar.notif.labelUnread": "Benachrichtigungen, {n} ungelesen",
  "topbar.notif.unread": "{n} ungelesen",
  "topbar.notif.allCaughtUp": "Alles gelesen",
  "topbar.notif.markAllRead": "Alle als gelesen markieren",
  "topbar.notif.loadError": "Benachrichtigungen konnten nicht geladen werden.",
  "topbar.notif.empty": "Keine Benachrichtigungen",
  "topbar.theme.toggle": "Design wechseln",
  "topbar.user.menu": "Kontomenü",
  "topbar.user.idCopied": "Kundennummer kopiert",
  "topbar.user.customer": "Kunde",
  "topbar.user.copy": "Kopieren",
  "topbar.user.copyId": "Kundennummer kopieren",
  "topbar.user.darkTheme": "Dunkles Design",
  "account.title": "Mein Konto",
  "account.working": "Bitte warten…",
  "account.close": "Schließen",
  "account.change": "Ändern",
  "account.enable": "Aktivieren",
  "account.disable": "Deaktivieren",
  "account.continue": "Weiter",
  "account.copied": "Kopiert",
  "account.password": "Passwort",
  "account.currentPassword": "Aktuelles Passwort",
  "account.logout.menu": "Abmelden",
  "account.logout.title": "Abmelden?",
  "account.logout.body": "Sie werden auf diesem Gerät abgemeldet. Verbundene Mailprogramme und SSH-Sitzungen bleiben aktiv.",
  "account.logout.cta": "Ja, abmelden",
  "account.logout.done": "Sie wurden abgemeldet",
  "account.profile.saved": "Profil gespeichert",
  "account.profile.fullName": "Vollständiger Name",
  "account.profile.email": "E-Mail-Adresse",
  "account.profile.currentPasswordHint": "Erforderlich, um Ihre E-Mail-Adresse zu ändern.",
  "account.security.title": "Sicherheit & 2FA",
  "account.security.description": "Verwalten Sie Ihr Passwort und die Zwei-Faktor-Authentifizierung.",
  "account.security.passwordSub": "Ändern Sie das Passwort, mit dem Sie sich anmelden.",
  "account.security.mfa": "Zwei-Faktor-Authentifizierung",
  "account.security.mfaActive": "Aktiv — Authenticator-App",
  "account.security.mfaOff": "Nicht aktiviert",
  "account.password.min": "Mindestens {n} Zeichen.",
  "account.password.mismatch": "Die Passwörter stimmen nicht überein.",
  "account.password.changed": "Passwort geändert",
  "account.password.wrongCurrent": "Ihr aktuelles Passwort ist nicht korrekt.",
  "account.password.changeTitle": "Passwort ändern",
  "account.password.new": "Neues Passwort",
  "account.password.confirm": "Neues Passwort bestätigen",
  "account.mfa.enabledTitle": "2FA ist aktiviert",
  "account.mfa.recoveryBody": "Bewahren Sie diese Wiederherstellungscodes an einem sicheren Ort auf. Jeder Code funktioniert einmal, falls Sie Ihr Telefon nicht zur Hand haben.",
  "account.mfa.saved": "Ich habe sie gespeichert",
  "account.mfa.enableTitle": "Zwei-Faktor-Authentifizierung aktivieren",
  "account.mfa.setupBody": "Fügen Sie dieses Konto mit dem Schlüssel unten zu Ihrer Authenticator-App hinzu (z. B. 1Password, Google Authenticator) und geben Sie anschließend den 6-stelligen Code ein.",
  "account.mfa.introBody": "Nach der Aktivierung fragen wir bei der Anmeldung zusätzlich nach einem Code aus Ihrer Authenticator-App.",
  "account.mfa.key": "Schlüssel",
  "account.mfa.openInApp": "In Authenticator-App öffnen",
  "account.mfa.copyKey": "Schlüssel kopieren",
  "account.mfa.codeFromApp": "Code aus der App",
  "account.mfa.disabled": "2FA deaktiviert",
  "account.mfa.disableTitle": "Zwei-Faktor-Authentifizierung deaktivieren",
  "account.mfa.disableBody": "Bestätigen Sie mit einem Code aus Ihrer Authenticator-App.",
  "account.mfa.code": "Code",
  "login.title": "Willkommen zurück",
  "login.subtitle": "Melden Sie sich an, um Ihr Hosting, Ihre Domains und E-Mails zu verwalten.",
  "login.mfaCode": "Code aus Ihrer Authenticator-App",
  "login.back": "Zurück",
  "login.submit": "Anmelden",
  "login.noAccount": "Noch kein Konto? Kontaktieren Sie uns.",
  "dashboard.mailboxCount.one": "{n} Postfach",
  "dashboard.mailboxCount.other": "{n} Postfächer",
  "addDomain.description.check": "Prüfen Sie, ob Ihre Domain frei ist, und registrieren Sie sie direkt.",
  "addDomain.checking": "Wird geprüft…",
  "addDomain.prices": "Preise pro Jahr: {list}",
  "addDomain.term.years.one": "{n} Jahr, danach jährliche Verlängerung",
  "addDomain.term.years.other": "{n} Jahre, danach jährliche Verlängerung",
  "addDomain.cost.price": "{amount}, auf Ihrer nächsten Rechnung",
  "addDomain.renew": "Verlängerung",
  "addDomain.renew.price": "{amount} pro Jahr",
  "addDomain.status.registered": "{domain} ist bereits registriert. Versuchen Sie einen anderen Namen oder eine andere Endung.",
  "addDomain.status.reserved": "{domain} ist reserviert und kann nicht registriert werden.",
  "addDomain.status.premium": "{domain} ist eine Premium-Domain. Kontaktieren Sie uns zu den Möglichkeiten.",
  "addDomain.status.invalid": "Dies ist kein gültiger Domainname.",
  "addDomain.status.unsupported_tld": "Diese Endung bieten wir (noch) nicht an.",
  "addDomain.status.unknown": "Wir konnten nicht feststellen, ob {domain} frei ist. Bitte versuchen Sie es später erneut.",
  "login.forgot": "Passwort vergessen?",
  "public.toLogin": "Zur Anmeldung",
  "public.missingToken": "Dieser Link ist unvollständig. Öffnen Sie den Link aus der E-Mail erneut oder kopieren Sie ihn vollständig.",
  "public.password.new": "Neues Passwort",
  "public.password.repeat": "Passwort wiederholen",
  "public.password.hint": "Mindestens {n} Zeichen.",
  "public.password.tooShort": "Ihr Passwort muss mindestens {n} Zeichen lang sein.",
  "public.password.mismatch": "Die Passwörter stimmen nicht überein.",
  "verify.title": "E-Mail-Adresse bestätigen",
  "verify.busy": "Ihre E-Mail-Adresse wird bestätigt…",
  "verify.ok": "Ihre E-Mail-Adresse ist bestätigt. Sie können sich jetzt anmelden.",
  "verify.invalid": "Dieser Bestätigungslink ist ungültig oder wurde bereits verwendet. Ist Ihre Adresse schon bestätigt, können Sie sich einfach anmelden.",
  "reset.request.title": "Passwort vergessen",
  "reset.request.sub": "Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link, um ein neues Passwort festzulegen.",
  "reset.request.submit": "Link senden",
  "reset.request.sent": "Falls ein Konto für {email} existiert, erhalten Sie in wenigen Minuten einen Link. Der Link ist 1 Stunde gültig.",
  "reset.title": "Neues Passwort festlegen",
  "reset.sub": "Wählen Sie ein neues Passwort für Ihr Konto.",
  "reset.submit": "Passwort speichern",
  "reset.done": "Ihr Passwort wurde geändert. Melden Sie sich mit dem neuen Passwort an.",
  "reset.invalid": "Dieser Link ist ungültig oder abgelaufen. Fordern Sie einen neuen an.",
  "reset.requestNew": "Neuen Link anfordern",
  "invite.title": "Einladung annehmen",
  "invite.sub": "Sie wurden zu DMRS Console eingeladen. Geben Sie Ihren Namen ein und wählen Sie ein Passwort, um Ihr Konto anzulegen.",
  "invite.name": "Vollständiger Name",
  "invite.submit": "Konto anlegen",
  "invite.done": "Ihr Konto wurde angelegt. Sie können sich jetzt anmelden.",
  "invite.done.email": "Ihr Konto wurde angelegt. Melden Sie sich mit {email} und Ihrem neuen Passwort an.",
  "invite.invalid": "Diese Einladung ist ungültig oder wurde bereits verwendet.",
  "invite.expired": "Diese Einladung ist abgelaufen. Bitten Sie die einladende Person um eine neue.",
  "invite.registered": "Für diese E-Mail-Adresse existiert bereits ein Konto. Melden Sie sich an oder setzen Sie Ihr Passwort zurück.",

  "addDomain.order.title": "{domain} bestellen",
  "addDomain.order.description": "Sie bezahlen über Mollie. Nach der Zahlung registrieren wir die Domain auf den unten angegebenen Inhaber.",
  "addDomain.pricePerYear": "Preis pro Jahr",
  "addDomain.period.one": "{n} Jahr",
  "addDomain.period.other": "{n} Jahre",
  "addDomain.period.price.one": "{n} Jahr · {amount}",
  "addDomain.period.price.other": "{n} Jahre · {amount}",
  "addDomain.vatNote": "Preise zzgl. 21 % MwSt.",
  "addDomain.pay": "Bestellen und bezahlen",
  "addDomain.redirecting": "Weiter zur Zahlung…",
  "addDomain.registered.title": "{domain} ist bereits registriert",
  "addDomain.registered.description": "Gehört Ihnen diese Domain? Verknüpfen Sie sie mit Ihrem Konto oder ziehen Sie sie zu uns um.",
  "addDomain.choice.link": "Sie gehört mir: verknüpfen",
  "addDomain.choice.link.sub": "Kostenlos. Die Registrierung bleibt bei Ihrem bisherigen Anbieter.",
  "addDomain.choice.transfer": "Zu uns umziehen",
  "addDomain.choice.transfer.sub": "{amount} zzgl. MwSt. Sie benötigen den Transfercode Ihres bisherigen Anbieters.",
  "addDomain.choice.transfer.unpriced": "Sie benötigen den Transfercode Ihres bisherigen Anbieters.",
  "addDomain.link": "Domain verknüpfen",
  "addDomain.linked": "{domain} wurde verknüpft",
  "addDomain.authCode": "Transfercode (EPP-Code)",
  "addDomain.authCode.hint": "Diesen Code erhalten Sie bei Ihrem bisherigen Anbieter.",
  "registrant.title": "Domaininhaber",
  "registrant.hint": "Diese Angaben werden bei der Registry hinterlegt.",
  "registrant.name": "Name",
  "registrant.company": "Firma (optional)",
  "registrant.address": "Adresse",
  "registrant.postalCode": "PLZ",
  "registrant.city": "Ort",
  "registrant.country": "Land",
  "registrant.phone": "Telefon",
  "registrant.phone.hint": "Zum Beispiel +49 30 1234567",
  "registrant.email": "E-Mail",
  "order.err.required": "Bitte füllen Sie dieses Feld aus.",
  "order.err.invalid": "Bitte prüfen Sie dieses Feld.",
  "order.err.fields": "Bitte prüfen Sie die markierten Felder.",
  "order.err.notRegistered": "{domain} ist nicht registriert und kann daher nicht umgezogen werden. Registrieren Sie sie stattdessen.",
  "order.err.alreadyManaged": "{domain} ist bereits bei uns registriert.",
  "order.err.orderExists": "Für {domain} gibt es bereits eine offene Bestellung. Sie finden sie auf der Domainseite.",
  "order.err.paymentFailed": "Die Bestellung wurde angelegt, aber die Zahlung konnte nicht starten. Bitte versuchen Sie es später über die Domainseite erneut.",
  "order.err.priceUnavailable": "Für diese Endung gibt es noch keinen Preis; sie kann derzeit nicht bestellt werden. Bitte kontaktieren Sie uns.",
  "orders.title": "Domainbestellungen",
  "orders.checking": "Bestellstatus wird abgerufen…",
  "orders.pay": "Bezahlen",
  "orders.details": "Technische Meldung",
  "orders.error.invalid_auth_code": "Der Transfercode (EPP) wurde abgelehnt. Fordern Sie bei Ihrem aktuellen Anbieter einen neuen Code an und versuchen Sie es erneut.",
  "orders.error.domain_unavailable": "Diese Domain ist nicht (mehr) zur Registrierung verfügbar.",
  "orders.error.transfer_refused": "Der aktuelle Registrar oder die Registry hat den Transfer abgelehnt. Prüfen Sie, ob die Domain entsperrt ist.",
  "orders.error.contact_invalid": "Die Inhaberdaten wurden nicht akzeptiert. Prüfen Sie Adresse und Telefonnummer.",
  "orders.error.price_unavailable": "Für diese Endung ist derzeit kein Preis verfügbar.",
  "orders.error.provider_error": "Der Registrar konnte die Bestellung nicht verarbeiten. Unser Team ist informiert und meldet sich bei Ihnen.",
  "orders.err.notPayable": "Diese Bestellung kann nicht mehr bezahlt werden.",
  "orders.action.register": "Registrierung",
  "orders.action.transfer": "Umzug",
  "orders.status.pending": "Wartet auf Zahlung",
  "orders.status.paid": "Bezahlt",
  "orders.status.provisioning": "In Bearbeitung",
  "orders.status.completed": "Abgeschlossen",
  "orders.status.failed": "Fehlgeschlagen",
  "orders.status.cancelled": "Storniert",
  "orders.msg.pending": "Wir haben Ihre Zahlung noch nicht erhalten.",
  "orders.msg.provisioning.register": "Zahlung erhalten. Wir registrieren die Domain jetzt.",
  "orders.msg.provisioning.transfer": "Zahlung erhalten. Wir beantragen den Umzug jetzt.",
  "orders.msg.completed.register": "{domain} ist registriert und steht in Ihrer Liste.",
  "orders.msg.completed.transfer": "Der Umzug von {domain} wurde beantragt. Das kann einige Tage dauern.",
  "orders.msg.failed": "Die Bearbeitung von {domain} ist fehlgeschlagen. Wir sind informiert und melden uns bei Ihnen.",
  "domainDetail.ns.modeDefault": "Standard",
  "domainDetail.ns.modeOwn": "Eigene Nameserver",
  "domainDetail.ns.ownDesc": "Mindestens zwei. Mit eigenen Nameservern verwalten Sie das DNS bei Ihrem eigenen Anbieter; die Einträge hier werden dann nicht mehr verwendet.",
  "domainDetail.ns.defaultExplain": "Wir verwalten die Zone und stellen die Nameserver bei der Registrierungsstelle ein. Ihre Einträge stehen bereit, bevor das geschieht.",
  "domainDetail.ns.registrarPicks": "Die Zone liegt bei unserer Registrierungsstelle, die die Nameserver selbst wählt.",
  "domainDetail.ns.source.own": "Von Ihnen angegeben",
  "domainDetail.ns.source.package": "Gehören zu Ihrem Hosting-Paket",
  "domainDetail.ns.source.global": "Unsere Standard-Nameserver",
  "domainDetail.ns.source.bunny": "Unsere Standard-Nameserver",
  "domainDetail.ns.source.registrar": "Von der Registrierungsstelle gewählt",
  "domainDetail.ns.state.ok": "Bei der Registrierungsstelle eingestellt",
  "domainDetail.ns.state.pending": "Wird bei der Registrierungsstelle eingestellt",
  "domainDetail.ns.state.other": "Stellen Sie diese bei Ihrer Registrierungsstelle ein",
  "domainDetail.dnssec.enabledPending": "DNSSEC eingeschaltet; der Schlüssel wird bei der Registry hinterlegt",
  "domainDetail.dnssec.state.off": "DNSSEC ist aus.",
  "domainDetail.dnssec.state.on": "Die Zone ist signiert und ihr Schlüssel liegt bei der Registry.",
  "domainDetail.dnssec.state.pending": "Die Zone ist signiert. Der Schlüssel wird so bald wie möglich bei der Registry hinterlegt.",
  "domainDetail.dnssec.state.copyDs": "Die Zone ist signiert. Hinterlegen Sie diesen DS-Eintrag bei der Registrierungsstelle Ihrer Domain:",
  "domainDetail.dnssec.legacyZone": "Diese Zone wird immer automatisch signiert.",
  "domainDetail.dnssec.ownNameservers": "Mit eigenen Nameservern regelt Ihr DNS-Anbieter DNSSEC.",
  "addDomain.prestage": "Nur vorbereiten",
  "addDomain.prestage.hint": "Vorbereiten: Sie richten das DNS jetzt ein und bestellen die Registrierung später. Dann funktioniert die Domain sofort.",
  "addDomain.prestaged": "{domain} ist vorbereitet. Richten Sie das DNS ein und bestellen Sie die Registrierung, wann Sie möchten.",
};
